<template>
    <div class="home" ref="home">
        <!-- 顶部活动广告 -->
        <!-- <div
            class="adv topAdv"
            v-if="showTopAdv"
            :style="{ backgroundImage: 'url(' + topAdv.src + ')' }"
        >
            <img :src="topAdv.src" alt="">
        </div>-->

        <!-- <home-nav :fixed="isFixed"></home-nav> -->
        <div style="height: 62px" v-show="isFixed"></div>
        <!-- 轮播图 或者 视频 -->
        <!-- 2023-01-09  start -->
        <div class="home-banner">
            <div class="home-banner-warp">
                <div class="banner-image">
                    <video autoplay loop muted
                        src="http://oss-zkwl-bs.oss-cn-beijing.aliyuncs.com/upload/20230406/1390a829b4a793018f1b34eb2f34a965.mp4"></video>
                </div>
                <div class="banner-hover">
                    <div class="hoverActive" :class="['samllImg' + (index + 2), bannerIndex == index ? 'active' : '']"
                        v-for="item, index in bannerSwiper" :key="index">
                        <div v-show="item.show" @mouseenter="changeBannerIndex(index)" @mouseleave="leaveBanner">
                            <div class="mySprite"></div>
                            <div class="textBox">
                                <div class="glass-wrap"></div>
                                <div class="contenBox">
                                    <div class="name">
                                        <img :src="item.img" :alt="item.name" />
                                        <h3>{{ item.name }}</h3>
                                    </div>
                                    <div class="intro">{{ item.intro }}</div>
                                    <a :href="item.link" target="_blank" class="myBtn">了解更多</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 图片banner -->
        <!-- <div class="home-banner">
            <div class="home-banner-warp">
                <div class="banner-image">
                    <img :src="banner" alt="">
                </div>
            </div>
        </div> -->
        <!-- 2023-01-09  end -->
        <div class="horse-race">
            <swiper class="swiper" :options="swiperOption">
                <swiper-slide v-for="item, index in swiperData" :key="index">
                    <a :href="item.href" target="_blank">
                        <img :src="item.thumb" alt="">
                    </a>
                </swiper-slide>
            </swiper>
        </div>
        <!-- 产业大脑 数智赋能 -->
        <div class="home-brain">
            <div class="w-1200-c">
                <div class="brain-left">
                    <div class="brain-left-title">产业大脑</div>
                    <div class="brain-left-line"></div>
                    <div class="brain-left-stitle">一脑治产业 两端同赋能</div>
                    <div class="brain-left-desc">以产业大脑为支撑，赋能政府侧、服务市场侧</div>
                    <div class="brain-left-desc" style="line-height:22px;font-size:14px;">
                        政府侧：围绕地方产业发展，实现产业全流程数字化、网络化、智能化、标准化，实现沧州工业大数据，为政府决策提供依据。</div>
                    <div class="brain-left-desc" style="line-height:22px;font-size:14px;margin-top:10px;">
                        市场侧：数字化实现企业精准匹配，激发企业活力，增添企业动力，加速企业高质量发展，实现高效协同，为企业服务有价值数据分析。</div>
                    <div class="brain-left-desc" style="line-height:22px;font-size:14px;margin-top:10px;">
                        “产业大脑”+“数字工厂”推动制造业模式变革，助力实现产业高质量发展。</div>
                </div>
                <div class="brain-right"></div>
            </div>
        </div>

        <!-- 产品 -->
        <div class="home-product" ref="product">
            <h4>产品和服务</h4>
            <h2>提供丰富、安全、稳定的产业智能化产品及服务</h2>
            <div class="product-tabs-box">
                <div class="product-tabs">
                    <div class="product-tabs-tab p-r-80" @click="changeProTab(1)">
                        <span :class="proTabIndex == 1 ? 'avtive' : ''">平台级产品</span>
                    </div>
                    <div class="product-tabs-tab p-l-80" @click="changeProTab(2)">
                        <span :class="proTabIndex == 2 ? 'avtive' : ''">应用级产品</span>
                    </div>
                    <div class="product-tabs-line"></div>
                </div>
            </div>
            <div class="product-line"></div>
            <div class="w-1200-c product-list">
                <div class="product-list-one">
                    <el-row :gutter="40">
                        <el-col :span="6" v-for="(item, index) in productListOne" :key="index">
                            <div class="product-item" @click="toModelUrl('product', item)">
                                <img :src="item.icon" alt />
                                <div class="product-name">{{ item.name }}<span class="el-icon-arrow-right"></span></div>
                                <div class="product-desc">{{ item.desc }}</div>
                                <div class="product-tags">
                                    <span v-for="(tag, j) in item.tags" :key="j">{{ tag }}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="product-list-two">
                    <el-row :gutter="40">
                        <el-col :span="6" v-for="(item, index) in productListTwo" :key="index">
                            <div class="product-item" @click="toModelUrl('product', item)">
                                <img :src="item.icon" alt />
                                <div class="product-name">
                                    {{ item.name }}
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                                <div class="product-desc">{{ item.desc }}</div>
                                <div class="product-tags">
                                    <span v-for="(tag, j) in item.tags" :key="j">{{ tag }}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="moreproduct" @click="toUrl('/softwareMarket/softwareHome')">查看更多</div>
        </div>

        <!-- 解决方案 -->
        <div class="home-plan" ref="plan">
            <h4>解决方案</h4>
            <h2>以产业大脑为支撑 数字经济系统为核心 探究行业共性需求</h2>
            <div class="w-1200-c">
                <div class="plan-content">
                    <div class="plan-left">
                        <div class="plan-left-tabs">
                            <ul>
                                <li :class="planTabIndex == index ? 'avtive' : ''" v-for="(item, index) in plan"
                                    :key="index" @click="changePlanTab(index)"
                                    :style="{ backgroundImage: 'url(' + item.thumb + ')' }">
                                    <span>{{ item.tabname }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="plan-right">
                        <div class="plan-right-content">
                            <div class="plan-right-title">{{ plan[planTabIndex].title }}</div>
                            <div class="plan-right-desc">{{ plan[planTabIndex].desc }}</div>
                            <div class="plan-right-button" @click="toModelUrl('solution', plan[planTabIndex])">了解详情</div>
                            <!-- <div class="plan-right-tags">
                                <span v-for="(tag, j) in plan[planTabIndex].tags" :key="j">{{ tag }}</span>
                            </div>-->
                            <div class="plan-right-tabicon">
                                <div class="plan-right-tab">
                                    <el-tabs v-model="planTabsIndex" @tab-click="changePlanTabItem">
                                        <el-tab-pane :label="item.name" :name="item.id"
                                            v-for="(item, index) in plan[planTabIndex].tabs" :key="index"></el-tab-pane>
                                    </el-tabs>
                                </div>
                                <div class="plan-right-icon">
                                    <div class="plan-right-iconitem" v-for="(item, index) in planTabChild" :key="index">
                                        <!-- <img src alt /> -->
                                        <div>{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="moreplan" @click="toUrl('/solutionlist')">
                <span>更多行业解决方案获取</span>
                <span class="el-icon-arrow-right"></span>
            </div>
        </div>

        <!-- 更多案例 -->
        <div class="home-case" ref="case">
            <div class="w-1200-c">
                <h4>行业经典案例</h4>
                <h2>跨行业跨领域为客户提供全链路数字化服务</h2>
            </div>
            <div class="w-1200-c">
                <div class="home-module-title">
                    <div class="home-module-text">工业诊所案例</div>
                    <!-- <div class="home-module-more">
                        更多产业案例
                        <span class="el-icon-arrow-right"></span>
                    </div>-->
                </div>
            </div>
            <div class="case-content">
                <div class="w-1200-c">
                    <div class="case-content-image">
                        <img :src="caseList[caseTabIndex].bigthumb" width="845" height="428" alt />
                        <div class="case-content-tab">
                            <div class="case-content-wrap" @mouseenter="clearCaseTimer" @mouseleave="startCaseTimer">
                                <div class="case-content-swiper">
                                    <div class="case-content-item" v-for="(item, index) in caseList" :key="index"
                                        :class="caseTabIndex == index ? 'active' : ''" @click="changeCaseTab(index)">
                                        <img :src="item.thumb" alt />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="case-content-text">
                        <div class="case-content-title">
                            {{ caseList[caseTabIndex].title }}
                            <p class="case-content-line"></p>
                        </div>
                        <div class="case-content-tag">{{ caseList[caseTabIndex].tag }}</div>
                        <div class="case-content-desc" v-html="caseList[caseTabIndex].desc"></div>
                        <!-- <div class="case-content-button">查看案例</div> -->
                    </div>
                </div>
            </div>
            <div class="w-1200-c">
                <div class="home-module-title">
                    <div class="home-module-text">行业案例</div>
                    <div class="home-module-more" @click="toUrl({ path: '/caseList' })">
                        更多行业案例
                        <span class="el-icon-arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="hangye-content">
                <div class="w-1200-c">
                    <div class="hangye-content-warp">
                        <div class="hangye-content-item" v-for="(item, index) in hangyeList" :key="index"
                            :style="{ backgroundImage: 'url(' + item.thumb + ')' }" @mouseover="hangyeAddAnimate"
                            @mouseout="hangyeRemoveAnimate" @click="toModelUrl('case', item)">
                            <div class="drawer">
                                <h3>{{ item.name }}</h3>
                                <h4 class="caseTitle"></h4>
                                <div class="caseIntro">{{ item.desc }}</div>
                                <div class="ripple-btn myBtn">了解更多</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          <div class="w-1200-c">
            <div class="home-module-title">
              <div class="home-module-text" style="margin-top: 20px">数字孪生案例</div>
            </div>
          </div>
          <div class="hangye-content">
            <div class="w-1200-c">
              <div class="zhuti szls">
                <el-row class="tabs">
                  <el-col span="4"  :offset="index!=0?1:0" v-for="(li,index) in anliList" :key="index">
                    <div class="tablist" :class="{'isactive':number==index}" @click="gotabs(index)">
                      <div class="tabimage"><el-image :src="li.icon"></el-image></div>
                      <div>{{li.title}}</div>
                      <div>{{li.titleSub}}</div>
                    </div>
                  </el-col>
                </el-row>
                <div class="anli">
                  <video ref="videoPlay" v-if="anliList[number].image.match('mp4')" autoplay muted loop class="video" controls="controls">
                    <source  src="" type="video/mp4">
                  </video>
                  <el-image v-else  :src="anliList[number].image"></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 广告轮播 -->
        <div class="home-adv-banner">
            <div class="w-1200-c">
                <div class="swiper">
                    <swiper ref="mSwiper" :options="mswiperOptions">
                        <swiper-slide v-for="(item, index) in mSwiperItem" :key="index">
                            <a style="display:block;"
                                href="https://www30c1.eiisys.com/webCompany.php?kf_sign=zcxODMTU1NU2MTEwODkzOTM1Njc0MDAyNzIxOTQ2NjM=&arg=10194663&style=1&language=cn&charset=GBK&kflist=off&kf=&zdkf_type=1&lnk_overflow=0&callback_id6ds=&referer=http%3A%2F%2Fwww.yy.com%2Fczgyy%2F&keyword=&tfrom=1&tpl=crystal_blue&uid=aedca1dea9cd16f94e1da2b8b9b43c88&is_group=&is_group=&timeStamp=1557718667185&ucust_id="
                                onclick="window.open(this.href, '_blank','width=820,height=610,top=200,left=550');return false">
                                <div class="adv-banner-item" :style="{ backgroundImage: 'url(' + item.src + ')', }"></div>
                            </a>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

        <!-- 新闻资讯 -->
        <div class="home-news" ref="news">
            <div class="w-1200-c">
                <h4>新闻资讯</h4>
                <h2>从这里 看见智能新工业的未来</h2>
                <div class="news-top">
                    <div class="news-top-left" @click="toGovsUrl(policyList[0])">
                        <h5>{{ policyList[0].linkTitle }}</h5>
                        <h6>{{ policyList[0].linkIntroduce }}</h6>
                        <p>{{ policyList[0].relType < 3 ? policyList[0].createTimeBiz : policyList[0].createTime }}</p>
                    </div>
                    <div class="news-top-right">
                        <div class="news-top-item news-top-itemx1" @click="toGovsUrl(policyList[1])"
                            style="margin-right:15px;">
                            <h5>{{ policyList[1].linkTitle }}</h5>
                            <p>{{ policyList[1].relType < 3 ? policyList[1].createTimeBiz : policyList[1].createTime }}</p>
                        </div>
                        <div class="news-top-item news-top-itemx2" @click="toGovsUrl(policyList[2])">
                            <h5>{{ policyList[2].linkTitle }}</h5>
                            <h6>{{ policyList[2].introduce }}</h6>
                            <p>{{ policyList[2].relType < 3 ? policyList[2].createTimeBiz : policyList[2].createTime }}</p>
                        </div>
                        <div class="news-top-item news-top-itemx2" style="margin-right:15px;">
                            <div class="swiper">
                                <swiper style="height:150px;" :options="newsSwiperOptions">
                                    <swiper-slide>
                                        <div @click="toGovsUrl(policyList[3])">
                                            <h5>{{ policyList[3].linkTitle }}</h5>
                                            <h6>{{ policyList[3].introduce }}</h6>
                                            <p>{{ policyList[3].relType < 3 ? policyList[3].createTimeBiz :
                                                policyList[3].createTime }}</p>
                                        </div>
                                    </swiper-slide>
                                    <!-- <swiper-slide>
                                        <div @click="toGovsUrl(policyList[4])">
                                            <h5>{{policyList[4].name}}</h5>
                                            <h6>{{policyList[4].introduce}}</h6>
                                            <p>{{policyList[4].createTime}}</p>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide>
                                        <div @click="toGovsUrl(policyList[5])">
                                            <h5>{{policyList[5].name}}</h5>
                                            <h6>{{policyList[5].introduce}}</h6>
                                            <p>{{policyList[5].createTime}}</p>
                                        </div>
                                    </swiper-slide> -->
                                </swiper>
                                <div class="swiper-pagination-news"></div>
                            </div>
                        </div>
                        <div class="news-top-item news-top-itemx1" @click="toGovsUrl(policyList[4])">
                            <h5>{{ policyList[4].linkTitle }}</h5>
                            <p>{{ policyList[4].relType < 3 ? policyList[4].createTimeBiz : policyList[4].createTime }}</p>
                        </div>
                    </div>
                </div>
                <div class="news-bot">
                    <div class="news-bot-tab">
                        <ul>
                            <li v-for="(item, index) in newsCateList" :key="index" @click="changeNewTab(index)"
                                :class="newsIndex == index ? 'active' : ''">{{ item.className }}</li>
                        </ul>
                        <p @click="toUrl('/companyNews')">进入新闻中心>></p>
                    </div>
                    <div class="news-bot-content" :style="{ backgroundImage: 'url(' + newsBg[newsIndex] + ')' }">
                        <ul>
                            <li v-for="(newsItem, j) in newsCateList[newsIndex].news" :key="j">
                                <router-link
                                    :to="{ path: '/companyNewsDetail', query: { id: newsItem.id, classId: newsItem.classId } }">
                                    <h4 class="title">{{ newsItem.newsName }}</h4>
                                    <p>{{ newsItem.updateTime }}</p>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 第一个广告模块 -->
        <div class="home-adv" v-if="showAdvOne" @click="toUrl('')" :style="{ backgroundImage: 'url(' + advOne.src + ')' }">
            <!-- <img :src="advOne.src" alt /> -->
            <div class="contact">
                <a style="display:block;width:100%;height:100%;color:#fff;"
                    href="https://www30c1.eiisys.com/webCompany.php?kf_sign=zcxODMTU1NU2MTEwODkzOTM1Njc0MDAyNzIxOTQ2NjM=&arg=10194663&style=1&language=cn&charset=GBK&kflist=off&kf=&zdkf_type=1&lnk_overflow=0&callback_id6ds=&referer=http%3A%2F%2Fwww.yy.com%2Fczgyy%2F&keyword=&tfrom=1&tpl=crystal_blue&uid=aedca1dea9cd16f94e1da2b8b9b43c88&is_group=&is_group=&timeStamp=1557718667185&ucust_id="
                    onclick="window.open(this.href, '_blank','width=820,height=610,top=200,left=550');return false">联系我们</a>
            </div>
        </div>
    </div>
</template>

<script>
// import homeNav from "@/components/home-nav";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    data() {
        return {
          anliList:[ {
            "id": "1792368719112970242",
            "name": "",
            "title": "车间产线 ",
            "titleSub": "数字孪生",
            "content": "",
            "image": "http://120.211.108.69:9000/idsp/upload/20240521/2ff949766ace1ceeff14be4cbdd8209f.mp4",
            "icon": "http://120.211.108.69:9000/idsp/upload/20240520/3bdae3fed710ce2bc23e4af82254fd25.png",
            "link": ""
          },
            {
              "id": "1792368813187014658",
              "name": "",
              "title": "智慧工厂",
              "titleSub": " 数字孪生",
              "content": "",
              "image": "http://120.211.108.69:9000/idsp/upload/20240521/a150916758c99feeaa58ba12ec844432.mp4",
              "icon": "http://120.211.108.69:9000/idsp/upload/20240520/b689ccaadfc56e073e701284653b7629.png",
              "link": ""
            },
            {
              "id": "1792369402759356417",
              "name": "",
              "title": "智慧园区 ",
              "titleSub": "数字孪生",
              "content": "",
              "image": "http://120.211.108.69:9000/idsp/upload/20240520/76a8893daf0ea088926195fe324eb421.png",
              "icon": "http://120.211.108.69:9000/idsp/upload/20240520/b6809d5aad78728f3c907506c1fc8548.png",
              "link": ""
            },
            {
              "id": "1792369492668456962",
              "name": "",
              "title": "智慧仓储 ",
              "titleSub": "数字孪生",
              "content": "",
              "image": "http://120.211.108.69:9000/idsp/upload/20240521/45990d70f31a8228676e4594768c0630.mp4",
              "icon": "http://120.211.108.69:9000/idsp/upload/20240520/97693e7d0a7cfd20d7d8f5f7964e13d8.png",
              "link": ""
            },
            {
              "id": "1792369567624863746",
              "name": "",
              "title": "智慧物流 ",
              "titleSub": "数字孪生",
              "content": "",
              "image": "http://120.211.108.69:9000/idsp/upload/20240520/a8bb0c75767db28754a6c6b2c00904b4.png",
              "icon": "http://120.211.108.69:9000/idsp/upload/20240520/b264f9fff8f5d8e7eb4bbca4906fdd68.png",
              "link": ""
            }],
          number:0,
            swiperOption: {
                slidesPerView: 6.18,
                spaceBetween: 5,
                speed: 8000,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                loop: true,
                // pagination: {
                //   el: '.swiper-pagination',
                //   clickable: true
                // },
            },
            swiperData: [
                {
                    id: 703,
                    href: "/SoftwareMarket/details?id=703",
                    thumb: require('../assets/pro-family/newswiper_1.png'),
                    h3: "标识解析应用",
                    p: "打通企业生产制造各环节，信息互通，数据共享、防伪防窜",
                },
                {
                    id: 716,
                    href: "/SoftwareMarket/details?id=716",
                    thumb: require('../assets/pro-family/newswiper_2.png'),
                    h3: "轻应用开发",
                    p: "帮助企业快速搭建云原生应用的低代码平台",
                },
                {
                    id: 683,
                    href: "/SoftwareMarket/details?id=683",
                    thumb: require('../assets/pro-family/newswiper_3.png'),
                    h3: "生产管理",
                    p: "对产品生产全过程控制与追踪，监管产品质量与制造过程细节",
                },
                {
                    id: 713,
                    href: "/SoftwareMarket/details?id=713",
                    thumb: require('../assets/pro-family/newswiper_4.png'),
                    h3: "VR可视化决策平台",
                    p: "虚拟现实工厂，沉浸式数据检测把控管理",
                },
                {
                    id: 720,
                    href: "/SoftwareMarket/details?id=720",
                    thumb: require('../assets/pro-family/newswiper_5.png'),
                    h3: "工控安全评估系统",
                    p: "加强和完善企业自身工控安全建设。",
                },
                {
                    id: 215,
                    href: "/SoftwareMarket/details?id=215",
                    thumb: require('../assets/pro-family/newswiper_6.png'),
                    h3: "设备管理",
                    p: "设备信息化管理、保障设备良好运行、降低设备故障率和事故率、节能降耗",
                },
                {
                    id: 715,
                    href: "/SoftwareMarket/details?id=715",
                    thumb: require('../assets/pro-family/newswiper_7.png'),
                    h3: "数字化管理大屏",
                    p: "实时采集系统数据，整合数据资源，统一展示分析处理",
                },
                {
                    id: 717,
                    href: "/SoftwareMarket/details?id=717",
                    thumb: require('../assets/pro-family/newswiper_8.png'),
                    h3: "企业诊断测评",
                    p: "针对企业核心业务能力、数据资产、人员组织全方位诊断。",
                },

            ],
            bannerIndex: 0,
            bannerTimer: null,
            bannerSwiper: [
                {
                    name: "数字孪生",
                    img: require("../assets/home/icon-popup-3.png"),
                    intro: "结合工业AI技术与工业机理，深度融合模型与数据，精确映射生产环境，从而实现仿真、分析和控制。",
                    link: "/SoftwareMarket/details?id=795",
                    show: true
                },
                {
                    name: "数字“身份证”",
                    img: require("../assets/home/icon-popup-1.png"),
                    intro: "唯一识别机器、产品等物理资源和算法、工序等虚拟资源的身份符号，实现企业间互联互通。",
                    link: "/trial",
                    show: true
                },
                {
                    name: "5G边缘计算",
                    img: require("../assets/home/icon-popup-2.png"),
                    intro: "对旋转设备的振动、噪声和温度进行三位一体实时监测，从而实现对设备故障及时诊断和预警，把事后维修变成事前预防。",
                    link: "/SoftwareMarket/details?id=723",
                    show: true
                },
                {
                    name: "工业物联网",
                    img: require("../assets/home/icon-popup-9.png"),
                    intro: "基于边缘计算、设备管理、数据采集的服务体系，一站式连接工业自动化设备、工业网关、企业信息化设备。",
                    link: "/industIot",
                    show: true
                },
                {
                    name: "标识解析",
                    img: require("../assets/home/icon-popup-5.png"),
                    intro: "打通制造业数字鸿沟，助力企业拥抱“数字机遇”，基于标识解析为工业企业提供信息化、数字化、智能化转型升级。",
                    link: "/identification",
                    show: true
                },
                // {
                //     name: "设备管理",
                //     img: require("../assets/home/icon-popup-6.png"),
                //     intro: "完善的管理方案，实现设备高效、可靠、安全的运行，大大降低设备管理维护成本。",
                //     link: "/SoftwareMarket/details?id=714",
                //     show: true
                // },
                {
                    name: "设备监测",
                    img: require("../assets/home/icon-popup-6.png"),
                    intro: "通过对设备运行状态进行实时监测和分析，帮助企业实现设备故障预警、维修保养等管理，提高设备可靠性和利用率。",
                    link: "",
                    show: true
                },
                {
                    name: "轻应用开发",
                    img: require("../assets/home/icon-popup-7.png"),
                    intro: "针对工业场景提供的生产力工具，面向广大工业互联网领域开发者，提供强大的可视化组态设计器与专业的线上IDE开发环境。",
                    link: "/lightapplication",
                    show: true
                },
                {
                    name: "工业大数据分析中心",
                    img: require("../assets/home/icon-popup-8.png"),
                    intro: "专注工业数据的采集、处理、分析，以SaaS化方式为企业提供数据全生命周期服务。",
                    link: "/industData",
                    show: true
                },
                {
                    name: "运行监测智慧平台",
                    img: require("../assets/home/icon-popup-8.png"),
                    intro: "对企业运营过程的全面监测和管理。帮助企业实现生产流程的优化、降低运营成本、提高生产效率和质量，从而提升企业的竞争力和盈利能力。",
                    link: "",
                    show: true
                },
            ],
            initPage: 0,
            isFixed: false,
            arrow: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/single_arrow.png",
            iconSrc: [
                "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/icon_04.png",
                "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/icon_05.png",
                "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/icon_07.png",
            ],
            showTopAdv: true,
            topAdv: {
                src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/topadv_01.png",
                link: "",
            },
            showAdvOne: true,
            advOne: {
                src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/adv_02.png",
                link: "",
            },
            showAdvTwo: true,
            advTwo: {
                src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/adv_04.png",
                link: "",
            },
            banner: require("../assets/img/banner_05.png"),
            bannerBg: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/bg-banner.png",
            // 解决方案
            planTabChild: [
                {
                    name: "生产管理（云MES）",
                    icon: "",
                },
                {
                    name: "VR可视化决策平台",
                    icon: "",
                },
                {
                    name: "数据管理大屏",
                    icon: "",
                },
                {
                    name: "企业级工业互联网",
                    icon: "",
                },
            ],
            planTabIndex: 0,
            planTabsIndex: "all",
            plan: [
                {
                    id: "1518759602629185538",
                    tabname: "汽车装备行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_1.png",
                    active: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_1_1.png",
                    title: "汽车装备行业解决方案",
                    desc: "基于工业互联网标识解析体系，集成MES系统，解决供应商原料标识不统一问题。数字化生产管控让生产过程透明化，优化生产流程，提升产能利用率，为决策提供数据化依据，提升客户满意度。",
                    tags: ["一物一码", "数据驱动", "协调共享", "智能引领"],
                    tabs: [
                        {
                            name: "全部",
                            id: "all",
                            child: [
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "标识解析",
                            id: "jiexi",
                            child: [
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "大数据",
                            id: "shuju",
                            child: [
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "其他",
                            id: "other",
                            child: [
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: "1518793130641264641",
                    tabname: "药包材行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_2.png",
                    active: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_2_1.png",
                    title: "药包材行业解决方案",
                    desc: "通过网络数据采集技术，在外部网站获取药企销售信息，进行数据整理，得出所需数据以支撑市场活动。通过数字化管理平台生产智能排产实现设备数据采集，实现车间人、机、物的高效协同，实现车间数字化。",
                    tags: ["一物一码", "数据驱动", "协调共享", "智能引领"],
                    tabs: [
                        {
                            name: "全部",
                            id: "all",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "标识解析",
                            id: "jiexi",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "大数据",
                            id: "shuju",
                            child: [
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "其他",
                            id: "other",
                            child: [
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: "1518767026144612353",
                    tabname: "食品行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_3.png",
                    active: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_3_1.jpg",
                    title: "食品行业解决方案",
                    desc: "为产品赋予唯一数字身份信息，实现从原材料、生产、仓储、物流、经销商、终端消费者各个环节的数据采集与跟踪监控，实现产品的全生命周期管理，精确掌控产品的流量、流向、流速等信息。",
                    tags: ["一物一码", "数据驱动", "协调共享", "智能引领"],
                    tabs: [
                        {
                            name: "全部",
                            id: "all",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "标识解析",
                            id: "jiexi",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "大数据",
                            id: "shuju",
                            child: [
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "其他",
                            id: "other",
                            child: [
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: "1518791088505950209",
                    tabname: "线缆行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_4.png",
                    active: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_4_1.jpg",
                    title: "线缆行业解决方案",
                    desc: "通过统一标识标准化供应原料，可有效识别供应商。上游供应商，其产品赋码加入标识解析，产品物流运输等行为同样加入标识解析。通过标识，将关联起企业信息、材料信息、型号规格、生产批次、运输批次等。",
                    tags: ["一物一码", "数据驱动", "协调共享", "智能引领"],
                    tabs: [
                        {
                            name: "全部",
                            id: "all",
                            child: [
                                {
                                    name: "客户管理（云CRM）",
                                    icon: "",
                                },
                                {
                                    name: "采购管理",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "设备管理",
                                    icon: "",
                                },
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "标识解析",
                            id: "jiexi",
                            child: [
                                {
                                    name: "客户管理（云CRM）",
                                    icon: "",
                                },
                                {
                                    name: "采购管理",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "设备管理",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "大数据",
                            id: "shuju",
                            child: [
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "其他",
                            id: "other",
                            child: [
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: "1518489698722127874",
                    tabname: "模具行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_5.png",
                    active: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_pic_5_1.jpg",
                    title: "模具行业解决方案",
                    desc: "以“标识”+“企业级互联网平台”+“应用系统”模式，集成了企业MES、CRM等，解决企业多系统孤岛问题。根据企业需求可定制化快速开发，统一标识体系建设，企业数字产品管理、设备管理可实现互联互通。",
                    tags: ["一物一码", "数据驱动", "协调共享", "智能引领"],
                    tabs: [
                        {
                            name: "全部",
                            id: "all",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "标识解析",
                            id: "jiexi",
                            child: [
                                {
                                    name: "云ERP",
                                    icon: "",
                                },
                                {
                                    name: "生产管理（云MES）",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "大数据",
                            id: "shuju",
                            child: [
                                {
                                    name: "VR可视化决策平台",
                                    icon: "",
                                },
                                {
                                    name: "数据管理大屏",
                                    icon: "",
                                },
                            ],
                        },
                        {
                            name: "其他",
                            id: "other",
                            child: [
                                {
                                    name: "企业级工业互联网",
                                    icon: "",
                                },
                                {
                                    name: "工业物联网",
                                    icon: "",
                                },
                            ],
                        },
                    ],
                },
            ],
            // 经典案例
            caseTabIndex: 0,
            caseList: [
                {
                    tag: "产业升级迭代 购销产一体化",
                    title: "轻应用定制开发平台 实现降本增效",
                    desc: "沧州某仪器仪表公司企业信息化系统应用程度较低，公司对于购销业务，仓库，生产和财务尚未进行信息化管理，使数据存在误差，工作效率较低，影响公司的正常运转。找寻适合产品和技术方案来进行升级和提高，目前购销、生产、仓储和收付款需实现降本增效，需求迫切。<br/>建议企业选用轻应用定制开发平台,为企业量身定制一套适合本企业业务流程的信息化软件。定制开发按照企业的实际情况和管理经验，能够准确、高效地管理跟踪客户订单、采购订单、以及仓库的综合管理，实现销售，采购，库存，生产，收付款，工资的数据互通，信息共享，便于数据的统计和分析，为领导提供最佳的决策建议。",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case1_1.png",
                    bigthumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case1.png",
                    city: "高新区",
                },
                {
                    tag: "智能化过程导向  实现客户高效管理",
                    title: "企业资源管理ERP 助力塑包行业数字化转型",
                    desc: "企业信息化系统应用程度较低，公司对于购销业务，仓库，生产，财务和固定资产尚未进行信息化管理，使数据存在误差，工作效率降低，影响公司的正常运转。找寻适合产品和技术方案来进行升级和提高，目前购销、生产、仓储，财务和固定资产实现降本增效需求迫切。<br/>建议企业选用ERP企业资源管理系统，并部署在云服务器上，ERP系统是一款标准化、智能化过程导向管理的管理软件，它结合了众多知名企业的实际情况和管理经验，能够准确、高效地管理跟踪客户订单、采购订单、以及仓库的综合管理。",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case2_1.png",
                    bigthumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case2.png",
                    city: "高新区",
                },
                {
                    tag: "客户持续跟踪记录 实现精准营销",
                    title: "以客户为中心 提高企业市场价值",
                    desc: "河北某集团有限公司属于典型的制造企业，企业信息化系统应用程度较高，企业已使用ERP管理系统，实现无纸化办公，信息化管理，业务财务一体化，但在客户管理上存在问题，无法对客户的售前，售中，售后详细记录和跟踪；需要一款对客户详细管理的软件，来解决企业现存在的问题。<br/>建议企业选用CRM客户管理 ，客户管理是企业用CRM技术来管理与客户之间的关系提高客户的价值、满意度、赢利性和忠实度来缩减销售周期和销售成本、增加收入、寻找扩展业务所需的新的市场和渠道，是选择和管理有价值客户及其关系的商业策略，CRM要求以客户为中心的企业文化来支持有效的市场营销、销售与服务流程的系统。",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case3_1.png",
                    bigthumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index-case/case3.png",
                    city: "高新区",
                },
                // {
                //     tag: "特色产业集群 人工智能装备 发展信息技术",
                //     title: "AI+工业互联网双创平台  产业依托",
                //     desc: "沧州高新区以高端装备双创平台为依托，规划建设了人工智能装备产业园；以华为云计算大数据中心、苏州纳米所为依托，规划建设了信息技术产业园。编制了两大产业的发展规划，分别设立了产业发展引导基金，出台了两大产业优惠扶持政策，全力打造智能装备、信息技术两大特色产业集群。新材料、节能环保、现代服务业也在这里快速聚集和发展。在这片投资兴业的热土上，聚集了中国航天太阳能光热、沧州明珠新材料、加拿大科光半导体等700余家高新技术企业，是河北省政府命名的节能环保示范区和军民融合产业示范区。",
                //     thumb: require("../assets/index-case/gaoxin_2.png"),
                //     bigthumb: require("../assets/index-case/gaoxin_3.png"),
                //     city: "高新区",
                // },
                // {
                //     tag: "专研工业方向/聚焦产业发展/实力铸造品牌",
                //     title: "聚集运河激光产业",
                //     desc: "运河区，隶属于河北省沧州市，也是沧州市政府所在地，因京杭大运河贯穿全境而命名。运河区位于沧州市区西部，总面积117.7平方公里，辖1乡1镇、6个街道办事处，63个行政村和51个社区。运河区东以清池大道为界与新华区毗邻，南、西两面与沧县接壤，北面与青县相连。运河区是沧州市交通的重要枢纽，京沪高铁沧州西站在此设站;京沪高速、黄石高速、307国道穿境而过。 沧州运河区激光产业园规划面积约11.66平方公里，辖区内涉及7个村、1个社区，常住人口2万余人。2014年辖区内主营业务收入21亿元，累计完成固定资产投资218亿元。运河工业园区激光产业确定为核心产业，制定了《沧州市运河区激光科技产业园产业规划（2014-2020）》，打造集“研发-装备制造-应用”于一体的沧州激光产业园——“北方光谷”，三年内建设成为年销售收入达100亿元的激光产业基地。激光加工国家工程研究中心京津冀区域中心落户建成，华工森茂特（华工科技控股）、沧州领创（苏州领创全资）、深圳沃克曼板材组合加工激光智能柔性生产线（激光冲床复合机）和鑫宇激光项目实现量产，德莱特激光、武汉高斯激光大幅面金属3D打印机、广东国工信高速智能数控系统产业化等十余个激光项目相继入驻，与预计年产值千亿元的北京二七轨道交通装备有限公司高端装备制造项目达成初步合作意向，其与德国WNB公司合作生产的物流机车、与西南交大、同济大学、中国磁悬浮技术研究中心共同研制的轻型中低速磁悬浮列车样车，正在沧州激光园区组织生产。激光加工国家工程研究中心京津冀区域中心、华工科技半导体激光切割机和三维机器人切焊机生产项目、领创激光、板材组合加工装备、高速智能数控系统，大幅面金属3D打印机均居国内或国际领先水平。",
                //     thumb: require("../assets/index-case/yunhe_2.png"),
                //     bigthumb: require("../assets/index-case/yunhe_3.png"),
                //     city: "运河区",
                // },
                // {
                //     tag: "振兴老化工业基地 强势发展新兴产业 新老产业碰撞并举齐发展",
                //     title: "构建新老并举工业产业结构",
                //     desc: "新华区隶属于河北省沧州市，地处沧州市区东半部，与运河区以清池大道为界，行政区域总面积88.5平方千米。新华区是沧州市老工业基地，华北重要的商品集散地。沧州市是全国三座化工城之一，新华区内有沧州大化TDI有限公司、沧州化工集团、中石化沧州炼油厂3家上市公司及中国第十三化工建筑公司、华北油田石油二部等多家国有大中型企业。同时，新华区形成了以石化、机械、电子、精密铸造、建材、轻工、房产开发、饮食服务等为主的产业体系。作为沧州市的老工业基地，新华区初步形成了以石油化工、石油装备制造等传统产业和电子信息、化学制药等新兴产业并举的工业产业结构。沧州炼油厂、达力普、华油飞达、爱姆帝电子、那瑞科技等成为具有较强影响力的行业龙头。新华区以化工、精铸、建材为龙头工业经济。辖区内坐落着中国石化沧州分公司、金牛化工、原化工部十三化建公司、中化集团沧州大化等省部级化工龙头企业。另外，大华构件厂、华凯工贸公司、恒华制衣等都是新华区的骨干企业。",
                //     thumb: require("../assets/index-case/xinhua_2.png"),
                //     bigthumb: require("../assets/index-case/xinhua_3.png"),
                //     city: "新华区",
                // },
                // {
                //     tag: "工业产业集群 优势开发 产业链加速发展",
                //     title: "发展规划特色产业集群",
                //     desc: "渤海新区依托临港经济技术开发区、港城石化产业园区和中捷石化产业园区，石油化工产业集群发展项目落地提供充足的空间。同时，渤海新区编制完成石油化工产业集群发展规划，石化重点骨干企业分别单独编制完成符合自身实际的智能改造方案。为加大对石化高新技术项目的扶持力度，渤海新区充分发挥沿海发展投资基金作用，正帮助旭阳化工己内酰胺项目争取1亿元注资。作为产业发展的“管家”，行业协会在引导企业发展中，发挥着至关重要的作用。渤海新区石油化工行业协会已发展会员单位40余家。石化综合服务中心在为石化企业提供信息、引才引智、创业辅导、培训、融资等服务的同时，依托鑫海化工和旭阳化工扎实的研发、检测能力以及齐全的实验设备，分别成立了石化研发、检测中心和新材料研发、检测中心，为石化及新材料企业提供产品研发、检验检测。渤海石化产业集群现有规模以上工业企业47家，2017年实现营业收入566.4亿元，同比增长30.9%，提前三年完成年营业收入达到500亿元目标，正朝着千亿级产业集群加速迈进，着力打造我国北方石化产业基地。",
                //     thumb: require("../assets/index-case/bohai_2.png"),
                //     bigthumb: require("../assets/index-case/bohai_3.png"),
                //     city: "渤海新区",
                // },
                // {
                //     tag: "聚焦产业发展 创新工业态势",
                //     title: "突出特色创新机制全面推进工业园区发展",
                //     desc: "我市坚持项目统揽，抓大的、建强的、引优的，北汽、鑫海、浅海、华晨、信诺立兴等“十大战略项目”成为渤海新区乃至沧州市观摩亮点。突出特色，创新机制，十五个工业园区全面推进，实现了“乡乡有园区”的历史性突破。目前基本形成经济开发区、城南常郭工业园、城东旧城工业园、城西滕庄子工业园、城北羊三木工业园组成的一个中心城区产业片区，临港羊二庄园区、临海南排河园区、临津齐家务园区、吕桥工业园等多个产业节点集聚发展的良好态势。重点培育了汽车装备、石油化工、五金制造、现代物流和服务业五大产业，形成了产业与城市互为支撑、相互促进的良好格局。特别是在汽车产业上，重点推进了北汽集团系列项目，总投资100亿元的北汽集团华北（黄骅）产业基地一期工程竣工，2013年12月26日实现整车下线，2014年7月31日实现威旺306汽车批量投产。北京现代最大配套商韩国世原项目落户黄骅，北汽集团将投资100亿元建设年产50万辆微车、30万辆发动机厂，把黄骅打造成60万辆整车基地，黄骅实现“汽车城”的梦想指日可待。",
                //     thumb: require("../assets/index-case/huanghua_2.png"),
                //     bigthumb: require("../assets/index-case/huanghua_3.png"),
                //     city: "黄骅市",
                // },
                // {
                //     tag: "特色产业集群 工业智能制造",
                //     title: "数字赋能  工业制造",
                //     desc: "沧县包装产业发展比较活跃，共有企业443家，从业人员13587人，主导产品是药用包装制品、纸箱及商标印刷等。药用包装主要集中在杜生镇及其周边地区，纸箱包装主要集中在仵龙堂乡东卷子和崔尔庄镇的部分村，商标印刷主要集中在薛官屯乡。杜生镇作为医药包装行业的集中地，已成为全国最大的北方药包材生产基地。",
                //     thumb: require("../assets/index-case/cangxian_2.png"),
                //     bigthumb: require("../assets/index-case/cangxian_3.png"),
                //     city: "沧县",
                // },
                // {
                //     tag: "聚焦产业发展/加工工业制造",
                //     title: "着力打造任丘创新孵化产业带",
                //     desc: "任丘市地处环京津、环渤海、环白洋淀“三环”区域，属“首都1小时经济圈”。市区北距北京151公里，东北距天津135公里。京九铁路纵贯全境，106国道、津保公路和开工建设的石津高速穿越市区，大广高速公路已经建成通车。全市总面积1036平方公里，总人口为89万人。现辖7个街道办事处（含3个油区办事处）、9个镇、6个乡、2个省级开发区（工业园区），413个行政村。“华北明珠”白洋淀位于市区西北10公里处。国家大型企业中国石油华北油田公司、华北石化公司驻在市区，是我国重要的石油化工基地。化工、机械、建材、农产品加工工业以采油为主，原油产量约古全国的1/20，我市拥有任丘经济开发区、雁翎工业园区两个省级开发区（工业园区）。 2017年全市生产总值达到641亿元，同比增长6.5%；规模以上工业增加值完成334.6亿元，增长4.6%；固定资产投资完成221.5亿元，增长10.1%；社会消费品零售总额完成211.5亿元，增长8.5%。一般公共预算收入完成32亿元，增长14.2%。城镇居民人均可支配收入预计完成33152元，同比增长8.2%；农村居民人均可支配收入预计完成15283元，同比增长8.5%。我市在全国中小城市综合实力百强县（市）中排名第47位，比去年跃升一位；在全国中小城市新型城镇化质量百强县（市）中排名第72位，在全国创新创业（双创）百强县市中排名第86位，在全国工业百强县（市）中排名第97位。",
                //     thumb: require("../assets/index-case/renqiu_2.png"),
                //     bigthumb: require("../assets/index-case/renqiu_3.png"),
                //     city: "任丘市",
                // },
                // {
                //     tag: "铸造产业发展/工业智能制造/产业协同加速",
                //     title: "布局泊头工业互联网新生态",
                //     desc: "泊头京杭大运河贯穿市区，因运河槽运兴起而得名。位于河北省东南部，北依京津，东临渤海，南接齐鲁，距北京市250公里，距塘沽港180公里，距黄骅港80公里。现拥有熔炼设备1000多台套，总熔化能力3000吨/小时，理化室60多个，光谱分析仪30多台。拥有铸造企业共500余家，产权结构以股份制和民营企业为主，企业主要分布于泊头市区及王武镇、交河镇、郝村镇、营子镇、寺门村镇、洼里王镇、泊镇等7个乡镇。固定资产原值40多亿元，从业人员2.8万人，年铸造设计生产能力400多万吨，年产量达200万吨，人均年生产能力100余吨，全市拥有国内外比较先进的全自动、半自动生产浇铸流水线30多条。主要产品有工业品和工艺品两大类，其中普通灰铁件占50%，球铁铸件占40%，其他有色铸件占10%。树脂砂造型生产能力占年产量的80%以上。目前，全市生产的大型机床铸件产量占全国份额的25%，汽车覆盖件模具铸件占全国份额的30%，工量具、平台铸件占全国份额的60%。铸件年生产能力在3000吨以上的企业有300多家，万吨以上企业50多家，60%的企业已通过或正在申请ISO9000认证。部分产品销往美国、日本、英国、德国、意大利等30多个国家和地区。2009年2月，泊头市因其在铸造行业的重要地位，被中国铸造协会授予“中国铸造之乡”荣誉称号，并颁发证书及牌匾；2012年5月又被中国铸造协会命名为“中国铸造名城”，并颁发证书及牌匾。",
                //     thumb: require("../assets/index-case/botou_2.png"),
                //     bigthumb: require("../assets/index-case/botou_3.png"),
                //     city: "泊头市",
                // },
                // {
                //     tag: "数字赋能  工业制造",
                //     title: "特色产业集群 工业智能制造",
                //     desc: "沧县包装产业发展比较活跃，共有企业443家，从业人员13587人，主导产品是药用包装制品、纸箱及商标印刷等。药用包装主要集中在杜生镇及其周边地区，纸箱包装主要集中在仵龙堂乡东卷子和崔尔庄镇的部分村，商标印刷主要集中在薛官屯乡。杜生镇作为医药包装行业的集中地，已成为全国最大的北方药包材生产基地。",
                //     thumb: require("../assets/index-case/cangxian_2.png"),
                //     bigthumb: require("../assets/index-case/cangxian_3.png"),
                //     city: "沧县",
                // },
                // {
                //     tag: "促进行业新生挖掘潜力资源重塑五金机电",
                //     title: "构建南皮机电智能制造新工业",
                //     desc: "南皮县位于沧州市中南部，地处环京津、环渤海经济区以及天津滨海新区的强力辐射带内，区位优势明显，交通四通八达。强力推进“工业强县、项目立县、开放兴县”三大战略，攻坚、提速、创优，县域经济得到快速发展，逐渐形成了独具特色的五金机电、玻璃制品、纺织服装三大特色产业。南皮作为中国五金机电制造基地，已有40多年的发展历程，五金机电配件产品种类多、辐射广，被广泛应用于卫星、火箭及国家大型机械设备上，中国第一颗人造地球卫星、神六、神七运载火箭上都有南皮的五金配件，因此早在上世纪70年代南皮就被命名为“中国北方电子五金之乡”。2007年被确定为“河北省五金机电特色产业基地”，2010年9月被中国机电产品进出口商会命名为“中国五金机电产品进出口基地”，2011年1月24日被中国机械工业联合会命名为“中国五金机电产品生产基地”。全县拥有五金机电企业2700多家，年产值60多亿元，从业人员7万人，有100余家企业通过ISO9000质量体系认证，90多家企业拥有自营进出口权，涌现出渤海牌榨油机、士达齿轮、利源椿西洋乐器、国华太阳能等一批知名产品。全县拥有惠邦、南风、益民、铁路信号、国华、瑞青等规模型企业100余家。部分骨干企业与通用、摩托罗拉、飞利浦、三星、LG、西门子、松下以及国内天津夏利、陕汽、海尔等集团建立了长期稳固的合作关系，成为跨国公司和国内知名企业的主要供货厂家。同时，南皮是华北地区有色金属、黑色金属的集散地，年购销铜材3万吨，黑色金属5万吨，并且拥有铜材专业生产厂家。为五金机电配套生产的模具加工业遍布城乡，县职教中心专门开办了电子电工、机械加工等专业，为五金机电产业培育了大批熟练的技术工人，全县形成了原材料生产、购销、模具加工、人才培训、五金机电制造于一体的产业集群。",
                //     thumb: require("../assets/index-case/nanpi_2.png"),
                //     bigthumb: require("../assets/index-case/nanpi_3.png"),
                //     city: "南皮县",
                // },
                // {
                //     tag: "完善产业链条/扶持新兴产业/构建工业布局",
                //     title: "抢先发力构建献县工业新生态",
                //     desc: "献县工业特色明显，是“中国扣件铸造之乡”，产品全国市场占有率达60%以上。新型产业：啤酒产业发展迅猛，已初步形成从玻璃模具、制瓶、制酒到啤酒外包装较为完整的产业链条。被评为“河北省十强特色产业”。随着企业规模不断扩大和科技投入不断增加，献县扣件铸造业已拥有建筑扣件、阀门、管件、机械铸件、异型铸件等九个系列，上千个品种，形成了国内扣件铸造产品品种最多、型号最全、规格最齐、产量最大的生产加工基地，目前已有26家企业通过了IS09000质量体系认证，11家企业被认定为科技型企业，拥有省级名牌产品7个，市级名牌产品8个，走上了依靠科技进步和提高产品质量求发展的轨道。 此外，献县扣件铸造业的销售网络遍布全国，常年在外经销和租赁扣件铸造产品的人员达1万多人，产品市场占有率逐年提高，扣件产品占到了全国市场份额的60%以上。许多产品销往日本、韩国、新加坡、俄罗斯等国家和地区。",
                //     thumb: require("../assets/index-case/xianxian_2.png"),
                //     bigthumb: require("../assets/index-case/xianxian_3.png"),
                //     city: "献县",
                // },
                // {
                //     tag: "集中优势力量/发展特色产业/布局营销网络",
                //     title: "集中发展孟村特色优势产业",
                //     desc: "孟村弯头管件业是特色优势产业。目前，孟村弯头管件行业总资产突破30亿元。现有1210家弯头管件企业，年吞吐量260万吨，年产量占全国总产量的三分之一。营销网络遍布到台湾以外的所有省、市、自治区。产品除打入三峡工程、西气东输等众多国家重点工程外，还出口20多个国家和地区。孟村在1996年被国务院发展研究中心评定命名为“中国弯头管件之乡”。",
                //     thumb: require("../assets/index-case/mengcun_2.png"),
                //     bigthumb: require("../assets/index-case/mengcun_3.png"),
                //     city: "孟村",
                // },
                // {
                //     tag: "完善生产体系/打造生机工业/各行业协同发展",
                //     title: "融合创新吴桥新工业 共享智能生态",
                //     desc: "吴桥县位于河北省东南部冀鲁交界处，总面积584平方公里，辖5乡5镇，473个行政村， 27．5万人口。吴桥历史悠久，人杰地灵，文化灿烂，是世界闻名的“杂技之乡”和河北省著名的侨乡。吴桥县为国务院批准的对外开放县，“吴桥经济技术开发区”是河北省人民政府批准的经济技术开发区。改革开放使吴桥工业如虎添翼，显现出勃勃生机。全县己形成机械、化工、轻工、建材、纺织、造纸、工具、工艺美术等行业为主的生产体系和农副产品加工体系。干蛋制品、蜂蜜产品、速冻保鲜蔬菜、纯净水、宫面、麦芽糊精、减速机、空压机、钢镐、抽纱、手绣毯等50多个品种， 2000多种以上规格的产品打入国际市场，远销40多个国素和地区。 吴桥地理位置优越，基础条件完备，处在京津、石家庄、济南等大中城市构成的“金三角”中心地带，京沪铁路、104国道、京沪高速公路、京杭大运河纵穿全境，境内外公路四通八达，水电供应充足。游乐、购物服务设施配套齐全，发达的电信业可为您与世界及全国各地的联系提供便利条件。",
                //     thumb: require("../assets/index-case/wuqiao_2.jpg"),
                //     bigthumb: require("../assets/index-case/wuqiao_3.jpg"),
                //     city: "吴桥县",
                // },
                // {
                //     tag: "工业基础雄厚/嫁接改造专家/扩大支柱产业",
                //     title: "研产销一体特色产业集群",
                //     desc: "河北省海兴县取“靠海而兴”之意得名，属国家批准的环渤海开发区一线的开放县。地处河北东南沿海，南接齐鲁，北望京津，总面积960平方公里，现辖7个乡镇、7个国营农场、197个行政村，人口20.35万。海兴工业基础雄厚，县乡工业形成以原盐、不锈钢餐具、工艺品、帆布、阀门、管配件、弹簧、汽车齿轮、化工、渔粉十大支柱产业，产品畅销全国，享誉海内外，便于通过嫁接改造等多种方式进行合资合作。以渔粉、丰年虫卵、渔网、体育器材、窗纱、毛袜加工业为特色的个体私营经济发展迅猛，其中渔粉业成为全国三大基地之一，从业人员２万人，加工厂家78个，有专业市场６个，年营销额６亿元，利税5600万元，是我国北方最大的动物蛋白基地。丰年虫卵成为全国最大的营销集散地之一，年产值6500万元，利税1000万元。渔网业年营销额3000万元，有8个专业村和近5000个专业户，产品占领沿海、江、湖、泊地区，成为名符其实的网具生产基地。 近年来，河北省海兴县采取政府积极引导、重点扶持的方式，大力推动体育器材产业发展，逐渐形成集研发、生产、销售为一体的特色产业集群，取得良好的经济效益。据了解，目前该县拥有各类体育器材专业生产企业100余家，年产值超12亿元，产品畅销国内并远销美国、俄罗斯、澳大利亚等国家和地区。",
                //     thumb: require("../assets/index-case/haixing_2.png"),
                //     bigthumb: require("../assets/index-case/haixing_3.png"),
                //     city: "海兴县",
                // },
                // {
                //     tag: "特色产业发展/集群效应显著/工业智能生产",
                //     title: "完善东光产业链条一体化发展",
                //     desc: "东光县纸箱机械产业是国家命名的--中国纸箱机械之乡河北省命名的--河北十强特色产业纸箱包装机械企业群体规模居全国首位，可生产五层、七层纸板生产线、高档水性印刷开槽机等系列整机30余种，配件500多种，拥有企业400多家。中小型纸箱机械产销量占国内市场份额的80%，部分产品出口俄罗斯、韩国等十几个国家和地区",
                //     thumb: require("../assets/index-case/dongguang_2.png"),
                //     bigthumb: require("../assets/index-case/dongguang_3.png"),
                //     city: "东光县",
                // },
                // {
                //     tag: "工业布局主导/产业发展集散/再制造产业升级",
                //     title: "创建工业再制造产业示范基地",
                //     desc: "河间县七大特色支柱产业河间——以工业为主导——的民营经济发展迅猛电线电缆 餐具汽车配件 新型建材保温材料 通讯器材轻纺化工中国工艺玻璃之都近年来，河北省河间市大力发展玻璃行业目前该市有工艺玻璃产品生产企业180余家今年，中国工艺美术协会授予河间市“中国工艺玻璃之都”称号“中国电线电缆生产基地”重要的“保温密封等新材料生产基地”中国北方最大的“汽车配件生产集散地”已形成电线电缆、保温材料、汽车配件三大传统产业和精细化工、信息设备、家居家饰三大新兴产业构建的“3＋3”产业体系，全市民营企业达到5624家。河间是闻名国内外的电线电缆生产基地，是中国北方重要的汽车配件、保温材料生产集散地、中国通讯器材生产基地、中国台布生产基地、中国工艺玻璃之都、中国耐热玻璃生产基地。河间电线电缆和保温材料产业被确认为省中小企业产业集群。汽车起动机、发电机再制造规模居世界第一，“京津冀国家再制造产业示范基地”获国家发改委批复，河间成为全国第四家、京津冀唯一一家国家级再制造产业示范基地。全市拥有“会友”“津桥”“仙桥”“康洁”“国欣”“冀阳”6个中国驰名商标和银龙、会友、凯瑞、明尚德等12家上市公司。",
                //     thumb: require("../assets/index-case/hejian_2.png"),
                //     bigthumb: require("../assets/index-case/hejian_3.png"),
                //     city: "河间县",
                // },
                // {
                //     tag: "京津产业辐射/扩张产业规模/创新有序发展",
                //     title: "加强青县数字赋能工业创新",
                //     desc: "青县电子机箱业起步于20世纪70年代末国营青县农场，最初是以“河北省国营青县电子机箱制板厂”为代表的两家国营企业，到90年代前后，开始在青县马厂乡和国营农场陆续出现了一批个体、联合体机箱企业。电子机箱产业快速发展始于上世纪90年代中期，在马厂乡规划建设1000亩杨官店机箱小区的带动以及京津产业的辐射下，到2000年园区机箱企业达到100多家，自此揭开了青县以农场和马厂为主产区，涵盖全县9个镇乡（场）的电子机箱产业发展序幕。第二个快速发展时期为2001—2008年，随着我国加入WTO，IT产业的发展以及国家对军工、通信、电力、铁路等基础设施的大力兴建设，青县机箱产业迎来了大发展的机遇，产业规模迅速扩张，截止到2012年，机箱企业发展到450多家，从业人员13498人，产值65.1亿元，同比增长27.9%，产品涵盖网络机柜、机电机柜、工控机箱、通讯机箱、电子监控机箱、电力机柜、医疗设备、教学设备等众多领域，产品上千种，市场覆盖全国20多个省市，成为中国北方最大的机箱生产基地，2011年被中国设备管理协会授予“中国电子机箱制造基地”称号。 ",
                //     thumb: require("../assets/index-case/qingxian_2.png"),
                //     bigthumb: require("../assets/index-case/qingxian_3.png"),
                //     city: "青县",
                // },
                // {
                //     tag: "布局工业新生态 立足源头创新孵化",
                //     title: "多产业协同发展工业",
                //     desc: "盐山经济开发区为省级开发区。2006年开发建设，已编制完成了《开发区总体规划》和《控制性详细规划》，实现了与《城乡总体规划》、《土地利用规划》的“三规合一”，开发区总规划面积32平方公里，未开发面积为20平方公里，为承接产业转移留足了空间。产业主要有管件管材类、机床附件类、体育器材类、精密铸造类、输送机械类、新能源类等，产品销往全国23个省，5个自治区，4个直辖市，2个特别行政区，还延伸到亚洲、美洲、欧洲、东南亚、中东、澳洲、南美洲、非洲等50多个国家和地区。30余家企业获得实用新型、外观设计等专利130多项，各种荣誉70多项。",
                //     thumb: require("../assets/index-case/yanshan_2.png"),
                //     bigthumb: require("../assets/index-case/yanshan_3.png"),
                //     city: "盐山县",
                // },
                // {
                //     tag: "发展特色主导产业 完善裘皮产业链",
                //     title: "集中发展肃宁特色优势产业",
                //     desc: "裘皮服装产业：为肃宁第一特色主导产业，目前已形成毛皮动物养殖、市场集散、原皮硝染、服装加工、研发设计、内外贸易完整的产业链。原皮交易雄踞全国首位，年交易量1.8亿张，年交易额250亿元，占全国年交易量70%；成衣贸易迅速崛起，年销售裘皮服装60余万件，是华北地区最大的裘皮服装贸易中心，产品远销俄罗斯、美国、意大利等30多个国家和地区，年外贸出口2亿美元，2017年裘皮业实现产值175亿元。连续举办十七届中国·肃宁国际皮草文化博览会，拥有怡嘉琦、赛格鸥两个中国驰名商标，2015年“肃宁裘皮”被国家质检总局批准为“国家地理标志保护产品”。肃宁先后被中国轻工业联合会、中国皮革协会命名为“中国裘皮之都”，被国家标准委确定为“国家级标准化特种动物养殖示范区”，被中国皮革协会命名为“中国裘皮基地”，被河北省政府确定为 “省级裘皮服装加工出口基地”",
                //     thumb: require("../assets/index-case/suning_2.png"),
                //     bigthumb: require("../assets/index-case/suning_3.png"),
                //     city: "肃宁市",
                // },
            ],
            caseTimer: null,
            //行业案例
            hangyeTabIndex: 0,
            hangyeList: [
                {
                    id: "1518826092002848770",
                    name: "汽车装备行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/case_image/1.jpg",
                    title: "汽车装备行业",
                    desc: "提升企业数字化，溯源管理",
                },
                {
                    id: "1518823889041141762",
                    name: "药包材行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/case_image/2.jpg",
                    title: "药包材行业",
                    desc: "数字化+自动化融合，助力企业效益跃升",
                },
                {
                    id: "1518828120598949889",
                    name: "模具行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/case_image/3.jpg",
                    title: "模具行业",
                    desc: "企业数字化升级，降本增效",
                },
                {
                    id: "1518844845604253698",
                    name: "电子制造行业",
                    thumb: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/case_image/4.jpg",
                    title: "电子制造行业",
                    desc: "精细化流程落地，提升运营效率和盈利能力",
                },
            ],
            // 政策发布
            newsList: [
                {
                    id: "",
                    src: "",
                    title: "新能源汽车销量攀升 动力电池企业忙扩产",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "全国首次中成药集中带量采购开标 预计每年节约药品费用超26亿元",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "机器人产业迎来跨越发展窗口期",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "钢铁企业迎来利润“大年”",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "钢铁企业迎来利润“大年”",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "钢铁企业迎来利润“大年”",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "钢铁企业迎来利润“大年”",
                    link: "",
                    time: "2020-02-02",
                },
                {
                    id: "",
                    src: "",
                    title: "钢铁企业迎来利润“大年”",
                    link: "",
                    time: "2020-02-02",
                },
            ],
            // 最新资讯
            mSwiperItem: [
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/pic_20.jpg",
                    name: "",
                    link: "",
                },
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/pic_20.jpg",
                    name: "",
                    link: "",
                },
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/pic_20.jpg",
                    name: "",
                    link: "",
                },
            ],
            // 最新资讯 轮播图设置
            mswiperOptions: {
                loop: true,
                // loopFillGroupWithBlank: true,
                speed: 500,
                // 改变swiper样式时，自动初始化swiper
                observer: true,
                // 监测swiper父元素，如果有变化则初始化swiper
                observeParents: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },

            },
            // 合作伙伴 轮播图设置
            newsSwiperOptions: {
                loop: true,
                // loopFillGroupWithBlank: true,
                speed: 300,
                // 改变swiper样式时，自动初始化swiper
                observer: true,
                // 监测swiper父元素，如果有变化则初始化swiper
                observeParents: true,
                autoplay: {
                    delay: 2000000,
                    disableOnInteraction: false,
                },
                direction: "vertical", //垂直切换
                pagination: {
                    // el: ".swiper-pagination-news",
                },
            },
            // 合作伙伴
            partner: [
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/partner01.png",
                    name: "",
                    link: "",
                },
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/partner02.png",
                    name: "",
                    link: "",
                },
                {
                    id: "",
                    src: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/partner03.png",
                    name: "",
                    link: "",
                },
            ],
            // proTabIndex
            proTabIndex: 1,
            productListOne: [
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_1.png",
                    name: "工业物联网平台",
                    desc: "实现设备互联互通、设备数据采集",
                    tags: ["药包材行业", "汽车装配行业", "电线电缆行业"],
                    id: 0,
                    to: "/industIot",
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_2.png",
                    name: "企业级互联网平台",
                    desc: "数据驱动为核心的网络化、扁平化、平台化的经营管理",
                    tags: ["汽车装配行业", "模具行业", "药包材行业"],
                    id: 0,
                    to: "/SoftwareMarket/details?id=718",
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_3.png",
                    name: "数据管理大屏",
                    desc: "实时采集系统数据，整合数据资源，统一展示分析处理",
                    tags: ["装备制造", "服装业", "生物医药"],
                    id: "715",
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_4.png",
                    name: "大数据开发平台",
                    desc: "基于云计算的智能化工业大数据平台",
                    tags: ["电子信息", "能源行业", "化工行业"],
                    id: 0,
                    to: "/industData",
                },
            ],
            productListTwo: [
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_5.png",
                    name: "轻应用开发平台",
                    desc: "帮助企业快速搭建云原生应用的低代码平台",
                    tags: ["电子信息行业", "食品加工行业", "化工行业"],
                    id: 0,
                    to: "/lightapplication",
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_6.png",
                    name: "工控安全系统",
                    desc: "针对工业控制系统提升整体网络安全防护能力",
                    tags: ["化工行业", "能源行业", "玻璃行业"],
                    id: 720,
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_7.png",
                    name: "VR可视化决策平台",
                    desc: "虚拟现实工厂，沉浸式数据检测把控管理",
                    tags: ["化工行业", "能源行业", "食品加工行业"],
                    id: 713,
                },
                {
                    icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_8.png",
                    name: "企业诊断测评",
                    desc: "针对企业核心业务能力、数据资产、人员...",
                    tags: ["化工行业", "能源行业", "电信电缆行业"],
                    id: 717,
                },
            ],
            addclass: 0,
            scrollTop: 0,
            settimer: null,
            caseTimerStatus: false,
            caseTimer: null,
            newsIndex: 0,
            newsBg: [
                // "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_new_bg.jpg",
                // "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_new_bg1.jpg",
                // "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_new_bg2.jpg",
                require("@/assets/home/index_new_bg.png"),
                require("@/assets/home/index_new_bg1.png"),
            ],
            policyList: [
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
                {
                    name: "",
                    updateTime: "",
                    introduce: "",
                },
            ],
            newsCateList: [{ news: [] }, { news: [] }],
        };
    },
    components: {
      // homeNav,
    },
    computed: {
        swiper() {
            return this.$refs.pSwiper.$swiper;
        },
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.videoPlay.src = this.anliList[0].image;
      });
        let _this = this;
        _this.initPage = 1;
        _this.containerAnimate();
        _this.getPolicyList();
        _this.getNewsList();
        _this.getCaseList();
        _this.leaveBanner(); //启动轮播图定时器
        window.addEventListener("scroll", this.handleScroll, true);
        // $(".topAdv").animate({ height: "62px" }, 800);
    },
    methods: {
      gotabs(index){
        this.number=index
        setTimeout(()=>{
          this.$refs.videoPlay.src = this.anliList[this.number].image;
        },500)
      },
        containerAnimate: function () {
            let _this = this;
            $(".info-container h2").attr("style", "");
            $(".info-container p").attr("style", "");
            $(".info-container h2")
                .stop(true)
                .animate({ opacity: 1, left: 0 }, 1200);
            this.settimer = setTimeout(() => {
                $(".info-container p")
                    .stop(true)
                    .animate({ opacity: 1, left: 0 }, 1200);
            }, 500);
            _this.timer = setInterval(() => {
                _this.tripleTabIndex++;
                if (_this.tripleTabIndex > 3) {
                    _this.tripleTabIndex = 1;
                }
                $(".info-container h2").attr("style", "");
                $(".info-container p").attr("style", "");
                $(".info-container h2")
                    .stop(true)
                    .animate({ opacity: 1, left: 0 }, 1200);
                setTimeout(function () {
                    $(".info-container p")
                        .stop(true)
                        .animate({ opacity: 1, left: 0 }, 1200);
                }, 500);
            }, 5000);
        },
        handleScroll: function (e) {
            let _this = this;
            _this.scrollTop = document.documentElement.scrollTop;
            _this.getBottomOfWindow();
        },
        changeBannerIndex(index) {
            clearInterval(this.bannerTimer);
            this.bannerIndex = index;
        },
        leaveBanner() {
            let _this = this;
            _this.bannerTimer = setInterval(() => {
                _this.bannerIndex++;
                if (_this.bannerIndex > _this.bannerSwiper.length - 1) {
                    _this.bannerIndex = 0;
                }
            }, 5000);
        },
        // 清除案例定时器
        clearCaseTimer() {
            clearInterval(this.caseTimer);
        },
        // 启动案例定时器
        startCaseTimer() {
            let _this = this,
                i = this.caseTabIndex;
            _this.caseTimer = setInterval(() => {
                _this.caseTabIndex++;
                if (_this.caseTabIndex > _this.caseList.length - 1) {
                    _this.caseTabIndex = 0;
                    $(".case-content-swiper").css({
                        transform: "translateX(0)",
                    });
                }
                if (
                    _this.caseTabIndex > 2 &&
                    _this.caseTabIndex < _this.caseList.length - 2
                ) {
                    $(".case-content-swiper").css({
                        transform:
                            "translateX(-" +
                            (_this.caseTabIndex - 2) * 120 +
                            "px)",
                    });
                }
            }, 3000);
        },
        getPolicyList() {
            this.$api.index
                .getPolicyList()
                .then((res) => {
                    if (res.data.length < 6) {
                        // let len = 6 - res.data.length;
                        // for (let i = 0; i < len; i++) {
                        //     res.data.push({
                        //         name: "",
                        //         updateTime: "",
                        //         introduce: "",
                        //     });
                        // }
                    }
                    this.policyList = res.data;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getNewsList() {
            this.$api.index
                .getNewsList()
                .then((res) => {
                    this.newsCateList = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCaseList() {
            this.$api.index
                .getCaseList()
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getBottomOfWindow: function () {
            var winHeight = window.innerHeight;
            // if (this.scrollTop > 62) {
            //     this.isFixed = true;
            // } else {
            //     this.isFixed = false;
            // }
            var productOneOffsetTop = $(".product-list-one").offset().top; //产品和服务
            var productTwoOffsetTop = $(".product-list-two").offset().top; //产品和服务
            if (productOneOffsetTop <= this.scrollTop + winHeight * 0.66) {
                $(".product-list-one").animate({ opacity: 1, top: 0 }, 800);
            }
            if (productTwoOffsetTop <= this.scrollTop + winHeight * 0.66) {
                $(".product-list-two").animate({ opacity: 1, top: 0 }, 800);
            }
            var planOffsetTop = $(".home-plan").offset().top; //解决方案距顶部距距离
            if (planOffsetTop <= this.scrollTop + winHeight * 0.66) {
                $(".plan-right").animate({ opacity: 1, left: 0 }, 800);
                $(".plan-left").animate({ opacity: 1, top: 0 }, 800);
            }
            var caseOffsetTop = $(".home-case").offset().top; //经典案例
            if (caseOffsetTop <= this.scrollTop + winHeight * 0.5) {
                $(".case-content-text").animate(
                    { opacity: 1, left: "35px" },
                    800
                );
                $(".case-content-tab").animate(
                    { opacity: 1, left: "27px" },
                    800
                );
                if (!this.caseTimerStatus) {
                    this.caseTimerStatus = true;
                    this.startCaseTimer();
                }
            }

            var hangyeOffsetTop = $(".hangye-content").offset().top; //行业案例
            if (hangyeOffsetTop <= this.scrollTop + winHeight * 0.66) {
                $(".hangye-content-warp").animate({ opacity: 1, top: 0 }, 800);
            }
        },
        hangyeAddAnimate() {
            $(".hangye-content-item").css({ width: "230px" });
        },
        hangyeRemoveAnimate() {
            $(".hangye-content-item").css({ width: "285px" });
        },
        toUrl(link) {
            if (!link) {
                return;
            }
            this.$router.push(link);
        },
        toNewsUrl(item) {
            if (!item) {
                return false;
            }
            // classId=1&id=1529992427494612994&newsClass=1
            let routeUrl = this.$router.resolve({
                path: "/companyNewsDetail",
                query: {
                    id: item.id,
                    classId: 1,
                    newsClass: 1
                },
            });
            window.open(routeUrl.href, "_blank");
        },
        toGovsUrl(item) {
            if (!item) {
                return false;
            }
            if (item.relType == 1) {
                // 关联新闻
                let routeUrl = this.$router.resolve({
                    path: "/companyNewsDetail",
                    query: {
                        id: item.relId,
                        classId: item.classId,
                    },
                });
                window.open(routeUrl.href, "_blank")
            } else if (item.relType == 2) {
                // 关联政策
                // relId
                let routeUrl = this.$router.resolve({
                    path: "/govNewsDetails",
                    query: {
                        id: item.relId,
                        topClass: item.classId,
                        classId: item.classId2
                    },
                });
                window.open(routeUrl.href, "_blank")
            } else {
                // 自定义链接
                window.open(item.linkUrl, "_blank")
            }
            // let routeUrl = this.$router.resolve({
            //     path: "/govNewsDetails",
            //     query: { 
            //         id:item.id,
            //         topClass:item.classId1,
            //         classId:item.classId2
            //     },
            // });
            // window.open(routeUrl.href, "_blank");
        },
        toModelUrl(model, item) {
            switch (model) {
                case "solution":
                    let routeUrl = this.$router.resolve({
                        path: "/solutionDetail",
                        query: { id: item.id },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                case "product":
                    let productUrl = "";
                    if (item.id == 0) {
                        productUrl = this.$router.resolve({
                            path: item.to,
                        });
                    } else {
                        productUrl = this.$router.resolve({
                            path: "/SoftwareMarket/details",
                            query: { id: item.id },
                        });
                    }
                    window.open(productUrl.href, "_blank");
                    break;
                case "case":
                    let caseUrl = "";
                    if (!item.id) {
                        return
                    } else {
                        caseUrl = this.$router.resolve({
                            path: "/caseDetail",
                            query: { id: item.id },
                        });
                    }
                    window.open(caseUrl.href, "_blank");
                    break;
            }
            // ''
        },
        changeNewTab(i) {
            this.newsIndex = i;
        },
        changePlanTab(i) {
            this.planTabIndex = i;
            let tabs = this.plan[i].tabs;
            // planTabsIndex//all
            this.planTabChild = tabs[0].child;
        },
        changePlanTabItem(tab, event) {
            // this.planTabsIndex = i;
            let tabs = this.plan[this.planTabIndex].tabs;
            // planTabsIndex//all
            tabs.forEach((el) => {
                if (el.id == tab.name) {
                    this.planTabChild = el.child;
                }
            });
        },
        changeCaseTab(i) {
            this.caseTabIndex = i;
            this.clearCaseTimer();
            if (i > 2 && i < this.caseList.length - 2) {
                $(".case-content-swiper").css({
                    transform: "translateX(-" + (i - 2) * 120 + "px)",
                });
            }
        },
        changeProTab(i) {
            this.proTabIndex = i;
            if (i == 1) {
                let productListOne = [
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_1.png",
                        name: "工业物联网平台",
                        desc: "实现设备互联互通、设备数据采集",
                        tags: ["药包材行业", "汽车装配行业", "电线电缆行业"],
                        id: 0,
                        to: "/industIot",
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_2.png",
                        name: "企业级互联网平台",
                        desc: "数据驱动为核心的网络化、扁平化、平台化的经营管理",
                        tags: ["汽车装配行业", "模具行业", "药包材行业"],
                        id: 0,
                        to: "/industInternet",
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_3.png",
                        name: "数据管理大屏",
                        desc: "实时采集系统数据，整合数据资源，统一展示分析处理",
                        tags: ["装备制造", "服装业", "生物医药"],
                        id: "715",
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_4.png",
                        name: "大数据开发平台",
                        desc: "基于云计算的智能化工业大数据平台",
                        tags: ["电子信息", "能源行业", "化工行业"],
                        id: 0,
                        to: "/industData",
                    },
                ];
                let productListTwo = [
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_5.png",
                        name: "轻应用开发平台",
                        desc: "帮助企业快速搭建云原生应用的低代码平台",
                        tags: ["电子信息行业", "食品加工行业", "化工行业"],
                        id: 0,
                        to: "/lightapplication",
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_6.png",
                        name: "工控安全系统",
                        desc: "针对工业控制系统提升整体网络安全防护能力",
                        tags: ["化工行业", "能源行业", "玻璃行业"],
                        id: 720,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_7.png",
                        name: "VR可视化决策平台",
                        desc: "虚拟现实工厂，沉浸式数据检测把控管理",
                        tags: ["化工行业", "能源行业", "食品加工行业"],
                        id: 713,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/ico_8.png",
                        name: "企业诊断测评",
                        desc: "针对企业核心业务能力、数据资产、人员...",
                        tags: ["化工行业", "能源行业", "电信电缆行业"],
                        id: 717,
                    },
                ];
                this.productListOne = productListOne;
                this.productListTwo = productListTwo;
                $(".product-tabs-line").animate({ left: 0 }, 300);
            } else {
                let productListOne = [
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/5.png",
                        name: "标识解析应用",
                        desc: "打通企业生产制造各环节，信息互通，数据共享、防伪防窜",
                        tags: ["药包材业", "模具行业", "汽车装配业"],
                        id: 703,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/6.png",
                        name: "协同办公（云OA）",
                        desc: "实现员工，信息、流程、应用多维度协同",
                        tags: ["电子信息", "模具行业", "药包材业"],
                        id: 678,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/7.png",
                        name: "企业资源计划管理(云ERP)",
                        desc: "企业内外部供需链上资源与信息进行统一的管理",
                        tags: ["模具行业", "汽车装配业", "化工行业"],
                        id: 765,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/8.png",
                        name: "生产管理（云MES）",
                        desc: "对产品生产全过程控制与追踪，监管产品质量与制造过程细节",
                        tags: ["能源工业", "化工行业", "汽车装配业"],
                        id: 683,
                    },
                ];
                let productListTwo = [
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/1.png",
                        name: "客户管理（云CRM）",
                        desc: "客户管理数字化、销售管理自动化、服务管理智能化、项目管理一体化",
                        tags: ["汽车装配业", "电线电缆业", "药包材业"],
                        id: 740,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/2.png",
                        name: "智能仓储（云WMS）",
                        desc: "智能自动化货位路线、推荐拣货路径管理，提高拣配货效率",
                        tags: ["汽车装配业", "电线电缆业", "药包材业"],
                        id: 154,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/3.png",
                        name: "设备管理（点检保养）",
                        desc: "设备信息化管理、保障设备良好运行、降低设备故障率和事故率、节能降耗",
                        tags: ["食品加工业", "能源行业", "化工行业"],
                        id: 714,
                    },
                    {
                        icon: "https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/product_icon/4.png",
                        name: "人员定位管理",
                        desc: "对车间人员考勤、跟踪定位、管理调度、应急报警及事故急救",
                        tags: ["化工行业", "能源行业", "管件铸造业"],
                        id: 677,
                    },
                ];
                this.productListOne = productListTwo;
                this.productListTwo = productListOne;
                $(".product-tabs-line").animate({ left: "218px" }, 300);
            }
        },
        changeTripleTab(i) {
            let _this = this;
            clearTimeout(_this.settimer);
            $(".info-container h2").attr("style", "");
            $(".info-container p").attr("style", "");
            _this.tripleTabIndex = i;
            $(".info-container h2")
                .stop(true)
                .animate({ opacity: 1, left: 0 }, 1200);
            this.settimer = setTimeout(() => {
                $(".info-container p")
                    .stop(true)
                    .animate({ opacity: 1, left: 0 }, 1200);
            }, 500);
            let timer = _this.timer;
            clearInterval(timer);
            _this.containerAnimate();
            // _this.timer = setInterval(() => {
            //     _this.tripleTabIndex++;
            //     if (_this.tripleTabIndex > 3) {
            //         _this.tripleTabIndex = 1;
            //     }
            //     $(".queue-anim-entering").attr("style", "");
            //     $(".info-container h2").animate({ opacity: 1, left: 0 }, 1200);
            //     setTimeout(function () {
            //         $(".info-container p").animate(
            //             { opacity: 1, left: 0 },
            //             1200
            //         );
            //     }, 500);
            // }, 5000);
        },
    },
};
</script>

<style lang="scss" scoped>
div,
p {
    box-sizing: border-box;
}

.w-1200-c {
    width: 1200px;
    margin: 0 auto;
}

.w-1400-c {
    width: 1400px;
    margin: 0 auto;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

h2,
h4 {
    font-weight: normal;
}

.home {

    // 顶部广告位
    // .topAdv {
    //     width: 100%;
    //     // height: 62px;
    //     height: 0;
    //     background-position: center;
    //     background-repeat: no-repeat;
    //     // background-size: auto 100%;
    //     background-size: cover;
    //     cursor: pointer;
    //     position: relative;
    //     z-index: 99;
    // }
    .home-banner {
        .home-banner-warp {
            width: 100%;
            position: relative;
            overflow: hidden;
            // height: 680px; // 2023-01-09
            height: 754px; // 2023-04-06  新视频banner
            min-width: 1200px;

            .banner-image {
                z-index: -1;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;

                img {
                    width: 100%;
                    display: block;
                    // height: 680px;
                }

                video {
                    display: block;
                    width: 100%;
                }
            }

            .banner-hover {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                border: 1px solid transparent;

                .hoverActive {
                    position: absolute;
                    z-index: 0;
                    width: 6.77%;
                    height: 19.1%;

                    .mySprite {
                        width: 130px;
                        height: 130px;
                        z-index: 3;
                        animation: myAnimation 1.6s steps(1) infinite;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background-image: url("../assets/home/dotAnima.png");
                        cursor: pointer;
                    }

                    .textBox {
                        position: absolute;
                        z-index: 1;
                        width: 10px;
                        height: 10px;
                        visibility: hidden;
                        top: calc(50% - 5px);
                        left: calc(50% - 5px);
                        transition: all ease-in-out 0.35s;

                        &::after,
                        &::before {
                            top: 0;
                            left: 0;
                            height: 100%;
                            width: 100%;
                            transform-origin: center;
                            content: "";
                            position: absolute;
                            z-index: -1;
                        }

                        &::before {
                            border-top: 1px solid #ffffff;
                            border-bottom: 1px solid #ffffff;
                            transform: scale3d(0, 1, 1);
                        }

                        &::after {
                            border-left: 1px solid #ffffff;
                            border-right: 1px solid #ffffff;
                            transform: scale3d(1, 0, 1);
                        }

                        .glass-wrap {
                            position: absolute;
                            height: calc(100% - 14px);
                            background: linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0.26));
                            backdrop-filter: blur(17px);
                            width: calc(100% - 14px);

                            &::after,
                            &::before {
                                width: 6px;
                                height: calc(100% + 20px);
                                content: "";
                                position: absolute;
                                top: -10px;
                                background: transparent;
                                z-index: 2;
                                transition: border linear 0.3s 1.3s;
                                transform-origin: center;
                            }

                            &::after {
                                left: -10px;
                            }

                            &::before {
                                right: -10px;
                            }
                        }

                        .contenBox {
                            height: 0;
                            visibility: hidden;
                            overflow: hidden;
                            position: relative;
                            background: linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0.26));

                            .name {
                                display: flex;
                                align-items: center;
                                margin: 10px 0;
                                padding: 0 18px;

                                img {
                                    width: 43px;
                                }

                                h3 {
                                    font-size: 18px;
                                    font-weight: 700;
                                    color: #333333;
                                    margin-bottom: 0;
                                }
                            }

                            .intro {
                                font-size: 12px;
                                color: #333333;
                                line-height: 24px;
                                padding: 0 20px;
                            }

                            .myBtn {
                                background-color: #3460f2;
                                padding: 0;
                                font-size: 14px;
                                width: 100%;
                                text-align: center;
                                color: #ffffff;
                                letter-spacing: 0;
                                display: block;
                                position: absolute;
                                top: calc(100% - 48px);
                                left: 0;
                                line-height: 48px;
                                opacity: 0;
                                height: 48px;
                                box-shadow: 0px 3px 11px 0px rgba(8, 46, 174, .47)
                            }
                        }
                    }
                }

                .active {
                    z-index: 1;

                    .textBox {
                        width: 323px;
                        height: 225px;
                        z-index: 3;
                        top: calc(50% - 130px);
                        left: calc(50% - 130px);
                        visibility: visible;
                        padding: 7px;

                        .contenBox {
                            height: 211px;
                            opacity: 1;
                            color: #333333;
                            visibility: visible;
                            transition: visibility 0.2s ease-in-out 0.3s,
                                height 0.2s ease-in-out 0.3s;
                            background: linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0.26));

                            .myBtn {
                                opacity: 1;
                                z-index: 6;
                                transition: opacity 0.5s ease-in-out 0.4s;
                            }
                        }

                        &::before,
                        &::after {
                            transform: scale3d(1, 1, 1);
                            transition: transform 0.5s 0.85s;
                        }

                        .glass-wrap::after,
                        .glass-wrap::before {
                            border-bottom: 6px solid #3460f2;
                            border-top: 6px solid #3460f2;
                        }
                    }
                }

                .samllImg1 {
                    top: 16%;
                    left: 42%;
                }

                .samllImg2 {
                    top: 10%;
                    right: 21%;
                }

                .samllImg3 {
                    top: 8%;
                    left: 50%;
                }

                .samllImg4 {
                    top: 60%;
                    left: 45%;
                }

                .samllImg5 {
                    top: 32%;
                    left: 57%;
                }

                .samllImg6 {
                    top: 8%;
                    left: 32%;
                }

                .samllImg7 {
                    top: 9%;
                    left: 62%;
                }

                .samllImg8 {
                    top: 25%;
                    left: 67%;
                }

                .samllImg9 {
                    top: 20%;
                    left: 26%;
                }

                .samllImg10 {
                    top: 33%;
                    left: 37%;
                }
            }
        }
    }

    @media only screen and (max-width: 1440px) {
        .home-banner {
            .home-banner-warp {
                // height: 508.5px;
                // width: 1440px;
            }
        }
    }

    @media only screen and (min-width: 1441px) and (max-width: 1621px) {
        .home-banner {
            .home-banner-warp {
                // height: 572.5px;
                // width: 1620px;
            }
        }
    }

    @media only screen and (min-width: 1622px) and (max-width: 1800px) {
        .home-banner {
            .home-banner-warp {
                // height: 636px;
                // width: 1800px;
            }
        }
    }

    @media only screen and (min-width: 1801px) and (max-width: 1920px) {
        .home-banner {
            .home-banner-warp {
                // height: 680px;
                // width: 1920px;
            }
        }
    }

    .home-brain {
        height: 548px;
        background: #f3f6ff;
        // background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_bg2.png");
        background-image: url("../assets/home/index_bg2.png");
        background-position: top center;
        background-repeat: no-repeat;

        .w-1200-c {
            padding-top: 1px;

            .brain-left {
                .brain-left-title {
                    font-size: 26px;
                    color: #000000;
                    line-height: 30px;
                    margin-top: 150px;
                }

                .brain-left-line {
                    width: 97px;
                    height: 5px;
                    background: #1f51c8;
                    margin-top: 20px;
                }

                .brain-left-stitle {
                    font-size: 20px;
                    color: #000000;
                    line-height: 23px;
                    margin-top: 38px;
                }

                .brain-left-desc {
                    margin-top: 15px;
                    width: 440px;
                    font-size: 16px;
                    color: #757f92;
                    line-height: 30px;
                }
            }

            .brain-right {}
        }
    }

    // 公用模块标题
    .home-module-title {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .home-module-text {
            font-size: 24px;
            color: #0b1d30;
            line-height: 28px;
            letter-spacing: 2px;
        }

        .home-module-more {
            font-size: 14px;
            color: #1f51c8;
            line-height: 16px;
            cursor: pointer;
            line-height: 28px;

            span {
                color: #1f51c8;
            }
        }
    }

    // 产品和服务
    .home-product {
        padding-bottom: 60px;
        padding-top: 80px;

        h4 {
            font-size: 28px;
            color: #0b1d30;
            text-align: center;
            margin-bottom: 20px;
        }

        h2 {
            font-size: 16px;
            color: #757f92;
            text-align: center;
            margin-bottom: 40px;
        }

        .product-tabs-box {
            display: flex;
            justify-content: center;

            .product-tabs {
                display: flex;
                font-size: 24px;
                color: #0b1d30;
                user-select: none;
                overflow: hidden;
                position: relative;

                .product-tabs-tab {
                    width: 218px;
                    text-align: center;
                    position: relative;
                    padding: 18px 0;
                    border: 0;
                    outline: none;
                    cursor: pointer;
                }

                .product-tabs-line {
                    width: 218px;
                    height: 6px;
                    background: linear-gradient(90deg,
                            #0d89db 0%,
                            #1c41e8 100%);
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
            }
        }

        .product-line {
            border-bottom: 1px solid #c8d1dd;
            margin-bottom: 58px;
        }

        .product-list {
            padding-left: 60px;
            box-sizing: border-box;
            position: relative;
            opacity: 1;

            .product-list-one {
                position: relative;
                top: -25px;
                opacity: 0;
            }

            .product-list-two {
                position: relative;
                top: -25px;
                opacity: 0;
            }
        }

        .product-item {
            margin-bottom: 50px;
            cursor: pointer;

            img {
                display: block;
                width: 50px;
                height: 50px;
                margin-bottom: 10px;
            }

            .product-name {
                font-size: 18px;
                margin-bottom: 20px;
                font-size: 18px;
                color: #000000;
                position: relative;

                .el-icon-arrow-right {
                    color: #1f51c8;
                    font-weight: 600;
                    display: none;
                }
            }

            .product-desc {
                width: 228px;
                color: #757f92;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                margin-bottom: 18px;
            }

            .product-tags {
                span {
                    display: inline-block;
                    border: 1px solid #c8d1dd;
                    margin-right: 6px;
                    margin-bottom: 6px;
                    font-size: 12px;
                    color: #757f92;
                    padding: 6px 17px;
                }

                span:hover {
                    background-color: #1f51c8;
                    color: #fff;
                    border-color: #1f51c8;
                }
            }
        }

        .product-item:hover {
            .product-name {
                color: #1f51c8;

                .el-icon-arrow-right {
                    display: inline;
                }
            }
        }

        .moreproduct {
            width: 120px;
            height: 36px;
            border: 1px solid #757f92;
            text-align: center;
            line-height: 36px;
            font-size: 14px;
            color: #757f92;
            margin: 10px auto 0;
            user-select: none;
            cursor: pointer;
        }
    }

    // 解决方案
    .home-plan {
        position: relative;
        background-color: #f9fafc;
        padding-top: 100px;
        background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_bg3.png");
        background-position: center;
        background-repeat: no-repeat;

        h4 {
            font-size: 28px;
            color: #0b1d30;
            text-align: center;
            margin-bottom: 20px;
        }

        h2 {
            font-size: 16px;
            color: #757f92;
            margin-bottom: 40px;
            text-align: center;
        }

        .plan-content {
            display: flex;

            .plan-left {
                position: relative;
                top: -25px;
                opacity: 0;

                .plan-left-tabs {
                    width: 330px;
                    font-size: 16px;
                    color: #757f92;
                    user-select: none;
                    border-right: 1px solid #e3e3e3;

                    ul {
                        width: 286px;

                        li {
                            margin-bottom: 15px;
                            width: 100%;
                            height: 82px;
                            background-color: #f5f7ff;
                            cursor: pointer;
                            line-height: 82px;
                            color: #000000;
                            padding-left: 30px;
                            box-sizing: border-box;
                            background-position: right center;
                            background-repeat: no-repeat;
                            background-size: auto 100%;
                            opacity: 0.45;
                        }

                        li.avtive {
                            opacity: 1;
                        }
                    }
                }
            }

            .plan-right {
                position: relative;
                left: 25px;
                opacity: 0;

                .plan-right-content {
                    padding-left: 40px;
                    box-sizing: border-box;

                    // position: relative;
                    // left: 25px;
                    // opacity: 0;
                    .plan-right-title {
                        font-size: 22px;
                        color: #0b1d30;
                        line-height: 26px;
                        letter-spacing: 2px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-bottom: 25px;
                    }

                    .plan-right-desc {
                        width: 740px;
                        font-size: 14px;
                        color: #757f92;
                        line-height: 24px;
                        letter-spacing: 1px;
                        margin-bottom: 25px;
                    }

                    .plan-right-tags {
                        margin-bottom: 60px;

                        span {
                            display: inline-block;
                            width: 63px;
                            height: 20px;
                            background: #494b58;
                            text-align: center;
                            line-height: 20px;
                            font-size: 12px;
                            color: #ffffff;
                            margin-right: 8px;
                        }
                    }

                    .plan-right-button {
                        width: 115px;
                        height: 40px;
                        background: #1f51c8;
                        font-size: 14px;
                        color: #ffffff;
                        line-height: 40px;
                        text-align: center;
                        margin-bottom: 20px;
                        box-shadow: 0px 3px 11px 0px rgba(8, 46, 174, 0.47);
                        cursor: pointer;
                    }

                    .plan-right-tabicon {
                        .plan-right-tab {
                            overflow: hidden;

                            /deep/ .el-tabs__item {
                                user-select: none;
                                line-height: 44px;
                                height: 44px;
                            }

                            /deep/ .el-tabs__nav-wrap::after {
                                height: 1px;
                                background-color: #f0f0f0;
                            }

                            // .plan-right-tabitem {
                            //     float: left;
                            //     margin-right: 34px;
                            //     font-size: 14px;
                            //     color: #757f92;
                            //     border-bottom: 2px solid transparent;
                            //     padding: 12px 0;
                            //     user-select: none;
                            //     cursor: pointer;
                            // }
                            // .plan-right-tabitem.active {
                            //     color: #1f51c8;
                            //     border-color: #1f51c8;
                            // }
                        }

                        .plan-right-icon {
                            margin-left: -5px;
                            margin-top: 5px;
                            overflow: hidden;

                            .plan-right-iconitem {
                                margin-bottom: 5px;
                                float: left;
                                display: flex;
                                padding-left: 22px;
                                box-sizing: border-box;
                                height: 80px;
                                width: 200px;
                                background-color: #fff;
                                margin-left: 5px;
                                transition: all 0.3s;
                                cursor: pointer;

                                img {
                                    display: block;
                                    width: 28px;
                                    height: 28px;
                                    margin-top: 26px;
                                    margin-right: 14px;
                                }

                                div {
                                    font-size: 14px;
                                    color: #757f92;
                                    line-height: 80px;
                                    width: 140px;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    transition: all 0.3s;
                                }
                            }

                            .plan-right-iconitem:hover {
                                background-color: #3460f2;

                                div {
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }
        }

        .moreplan {
            text-align: center;
            cursor: pointer;
            font-size: 14px;
            color: #1f51c8;
            line-height: 16px;
            margin-top: 40px;
        }
    }



    .horse-race {
        width: 100%;
        overflow: hidden;
        margin-top: 15px;
        margin-bottom: 15px;

        .swiper {
            width: 2170px;
            height: 100px;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;

            .swiper-slide {
                width: 300px;
                height: 100px;
                margin: 0 5px;
                background-color: #F4F5F7;

                a {
                    display: flex;
                    // padding: 20px 10px 20px 15px;
                    align-items: center;

                    img {
                        // width: 60px;
                        // height: 60px;
                        // margin-right: 10px;
                        width: 100%;
                    }

                    div {
                        h3 {
                            font-weight: normal;
                            font-size: 16px;
                            height: 20px;
                            line-height: 20px;
                            margin-bottom: 5px;
                        }

                        p {
                            font-size: 12px;
                            height: 36px;
                            line-height: 18px;
                            color: #757F92;
                        }
                    }
                }
            }
        }
    }

    // 经典案例
    .home-case {
        padding-bottom: 40px;
        padding-top: 80px;

        h4 {
            font-size: 28px;
            color: #0b1d30;
            text-align: center;
            margin-bottom: 20px;
        }

        h2 {
            font-size: 16px;
            color: #757f92;
            text-align: center;
            margin-bottom: 60px;
        }

        .case-tabs {}

        .case-content {
            padding-top: 20px;
            padding-bottom: 50px;
            height: 498px;
            background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/index_bg5.jpg");
            background-position: center;
            background-repeat: no-repeat;
            overflow: hidden;

            .case-content-image {
                position: relative;

                .case-content-tab {
                    position: absolute;
                    overflow: hidden;
                    margin-left: -10px;
                    bottom: 42px;
                    left: 0px;
                    opacity: 0;
                    width: 610px;
                    overflow: hidden;

                    .case-content-wrap {
                        .case-content-swiper {
                            width: 9999px;
                            height: auto;
                            overflow: hidden;
                            transition: 0.5s;

                            .case-content-item {
                                width: 110px;
                                height: 74px;
                                float: left;
                                margin-left: 10px;
                                background: #fff;
                                overflow: hidden;

                                img {
                                    display: block;
                                    transition: all ease-in-out 0.5s;
                                    filter: grayscale(100%);
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .case-content-item.active {
                                img {
                                    filter: grayscale(0);
                                }
                            }

                            .case-content-item:hover {
                                img {
                                    transform: scale(1.1);
                                }
                            }
                        }
                    }
                }
            }

            .case-content-text {
                box-sizing: border-box;
                width: 590px;
                height: 355px;
                position: relative;
                top: -390px;
                background: #fff;
                float: right;
                padding: 40px 45px 0;
                box-shadow: 0px 0px 10px 1px rgba(55, 99, 170, 0.15);
                left: 70px;
                opacity: 0;

                .case-content-title {
                    color: #0b1d30;
                    font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
                    font-size: 24px;
                    line-height: 28px;
                    letter-spacing: 1px;
                }

                .case-content-line {
                    width: 115px;
                    height: 3px;
                    background: #006fff;
                    margin-top: 15px;
                    margin-bottom: 25px;
                }

                .case-content-desc {
                    font-size: 12px;
                    color: #757f92;
                    line-height: 28px;
                    // display: -webkit-box;
                    // -webkit-box-orient: vertical;
                    // -webkit-line-clamp: 6;
                    // overflow: hidden;
                    height: 168px;
                    overflow-y: scroll;
                }

                .case-content-tag {
                    font-size: 16px;
                    color: #757f92;
                    line-height: 19px;
                    margin-bottom: 25px;
                }

                .case-content-button {
                    width: 122px;
                    height: 40px;
                    background: #1f51c8;
                    text-align: center;
                    line-height: 40px;
                    color: #fff;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }

        .hangye-content {
            margin-top: 50px;

            .w-1200-c {
                .hangye-content-warp {
                    overflow: hidden;
                    margin-left: -20px;
                    position: relative;
                    top: -25px;
                    opacity: 0;
                    display: flex;

                    .hangye-content-item {
                        width: 285px;
                        height: 294px;
                        background-color: #ccc;
                        // float: left;
                        margin-left: 20px;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: cover;
                        transition: all ease-in-out 0.3s;
                        position: relative;

                        .drawer {
                            position: absolute;
                            bottom: 0;
                            transition: all ease-in-out 0.3s;
                            overflow: hidden;
                            height: 85px;
                            width: 100%;
                            padding: 20px 9px;

                            h3 {
                                margin-top: 10px;
                                height: 20px;
                                font-size: 14px;
                                line-height: 20px;
                                font-weight: 700;
                                color: #fff;
                                margin-bottom: 36px;
                                position: relative;
                            }

                            h3::before {
                                width: 32px;
                                height: 3px;
                                background: #fff;
                                bottom: -18px;
                                position: absolute;
                                content: "";
                                left: 0;
                            }

                            h4 {
                                text-align: left;
                            }

                            .caseTitle {
                                font-size: 18px;
                                font-weight: 400;
                                color: #fff;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                margin-bottom: 15px;
                            }

                            .caseIntro {
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                overflow: hidden;
                                font-size: 14px;
                                color: #fff;
                                line-height: 22px;
                                font-weight: 400;
                                text-align: left;
                                margin-bottom: 15px;
                                min-height: 44px;
                            }

                            .myBtn {
                                background-color: #3460f2;
                                box-shadow: 0px 3px 11px 0px rgba(8, 46, 174, 0.47);
                                text-align: center;
                                font-size: 14px;
                                font-weight: 700;
                                color: #ffffff;
                                letter-spacing: 1px;
                            }

                            .ripple-btn {
                                position: relative;
                                display: inline-block;
                                width: 100px;
                                line-height: 38px;
                                height: 40px;
                                border: 1px solid #3460f2;
                                text-align: center;
                                overflow: hidden;
                                cursor: pointer;
                            }
                        }
                    }

                    .hangye-content-item:hover {
                        width: 450px !important;

                        .drawer {
                            height: 100%;
                            background: rgba(0, 12, 58, 0.6);
                        }

                        // 55px
                    }
                }
            }
        }
    }

    .home-adv-banner {
        margin-top: 55px;
        margin-bottom: 100px;

        .adv-banner-item {
            height: 240px;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
        }

        .swiper {
            .swiper-pagination {
                left: 0;
                right: 0;
                margin: 30px auto 0;

                /deep/ .swiper-pagination-bullet {
                    width: 15px;
                    height: 15px;
                    margin: 0 7.5px;
                }
            }
        }
    }

    // 两个活动广告位
    .home-adv {
        cursor: pointer;
        width: 100%;
        height: 240px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        // img {
        //     width: 100%;
        //     height: auto;
        //     display: block;
        // }
        position: relative;

        .contact {
            width: 100px;
            height: 40px;
            background: #1f51c8;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            color: #ffffff;
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            margin: 0 auto 28px;
        }
    }

    //新闻资讯
    .home-news {
        padding-bottom: 90px;

        h4 {
            font-size: 28px;
            color: #0b1d30;
            text-align: center;
            margin-bottom: 20px;
        }

        h2 {
            font-size: 16px;
            color: #757f92;
            text-align: center;
            margin-bottom: 60px;
        }

        .news-top {
            display: flex;
            justify-content: space-between;

            .news-top-left {
                width: 390px;
                height: 415px;
                background: url(../assets/home/home-news1.png) no-repeat center center;
                padding: 60px 30px 20px 40px;
                position: relative;
                cursor: pointer;

                h5 {
                    width: 272px;
                    font-size: 16px;
                    color: #0b1d30;
                    line-height: 26px;
                    font-weight: normal;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    margin-bottom: 30px;
                    text-align: justify;
                }

                h6 {
                    font-size: 14px;
                    color: #757f92;
                    line-height: 24px;
                    font-weight: normal;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 7;
                    overflow: hidden;
                    margin-bottom: 60px;
                }

                p {
                    font-size: 14px;
                    color: #757f92;
                    line-height: 24px;
                }
            }

            .news-top-right {
                width: 795px;
                height: 415px;
                display: flex;
                flex-wrap: wrap;

                .news-top-item {
                    height: 200px;
                    background: #eee;
                    margin-bottom: 15px;
                    cursor: pointer;

                    h5 {
                        width: 272px;
                        font-size: 16px;
                        color: #0b1d30;
                        line-height: 26px;
                        font-weight: normal;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        margin-bottom: 15px;
                        text-align: justify;
                        height: 52px;
                    }

                    h6 {
                        font-size: 14px;
                        color: #757f92;
                        line-height: 24px;
                        font-weight: normal;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        margin-bottom: 12px;
                        height: 48px;
                    }

                    p {
                        font-size: 14px;
                        color: #757f92;
                        line-height: 24px;
                    }
                }

                .news-top-itemx1 {
                    width: 250px;
                    padding: 30px 40px 20px 40px;

                    h5 {
                        width: 185px;
                        margin-bottom: 75px;
                    }
                }

                .news-top-itemx2 {
                    width: 530px;
                    padding: 30px 168px 20px 40px;
                    position: relative;

                    h5 {
                        width: 322px;
                    }

                    .swiper {
                        .swiper-pagination-news {
                            width: 10px;
                            position: absolute;
                            top: 0;
                            bottom: 0;
                            right: 15px;
                            margin: auto;
                            display: flex;
                            justify-content: center;
                            align-content: center; //主轴居中对齐
                            align-items: center; //交叉轴的中点对齐
                            flex-wrap: wrap;

                            /deep/ .swiper-pagination-bullet {
                                display: block;
                                margin: 5px 0;
                            }
                        }
                    }
                }

                .news-top-item:nth-child(2) {
                    background: url(../assets/home/home-news4.png) no-repeat center center;
                }

                .news-top-item:nth-child(3) {
                    background: url(../assets/home/home-news5.jpg) no-repeat center center;
                }
            }
        }

        .news-bot {
            background-color: #f8f8f8;
            padding: 18px;
            margin-top: 20px;

            .news-bot-tab {
                display: flex;
                justify-content: space-between;
                user-select: none;

                ul {
                    overflow: hidden;
                    padding-left: 10px;

                    li {
                        float: left;
                        padding: 11px 28px;
                        font-size: 14px;
                        color: #0b1d30;
                        line-height: 16px;
                        cursor: pointer;
                    }

                    li.active {
                        background-color: #fff;
                        color: #0070ff;
                    }
                }

                p {
                    font-size: 14px;
                    color: #0070ff;
                    line-height: 16px;
                    cursor: pointer;
                    line-height: 38px;
                }
            }

            .news-bot-content {
                height: 282px;
                overflow-y: scroll;
                width: 1170px;

                ul {
                    li {
                        width: 660px;
                        margin-left: 29px;

                        a {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            height: 65px;

                            h4 {
                                height: auto !important;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 16px;
                                color: #000000;
                                line-height: 24px;
                                margin-bottom: 0;
                                max-width: 500px;
                            }

                            p {
                                margin-top: 8px;
                                font-size: 14px;
                                color: #555555;
                                line-height: 24px;
                            }
                        }
                    }

                    li:not(:first-child) {
                        border-top: 1px solid #e3e3e3;
                    }

                    li:hover {
                        a {
                            h4 {
                                color: #3460f2;
                            }
                        }
                    }
                }
            }
        }
    }
}

@keyframes myAnimation {
    0% {
        background-position-x: 0px;
    }

    2.56% {
        background-position-x: -120px;
    }

    5.13% {
        background-position-x: -240px;
    }

    7.69% {
        background-position-x: -360px;
    }

    10.26% {
        background-position-x: -480px;
    }

    12.82% {
        background-position-x: -600px;
    }

    15.38% {
        background-position-x: -720px;
    }

    17.95% {
        background-position-x: -840px;
    }

    20.51% {
        background-position-x: -960px;
    }

    23.08% {
        background-position-x: -1080px;
    }

    25.64% {
        background-position-x: -1200px;
    }

    28.21% {
        background-position-x: -1320px;
    }

    30.77% {
        background-position-x: -1440px;
    }

    33.33% {
        background-position-x: -1560px;
    }

    35.90% {
        background-position-x: -1680px;
    }

    38.46% {
        background-position-x: -1800px;
    }

    41.03% {
        background-position-x: -1920px;
    }

    43.59% {
        background-position-x: -2040px;
    }

    46.15% {
        background-position-x: -2160px;
    }

    48.72% {
        background-position-x: -2280px;
    }

    51.28% {
        background-position-x: -2400px;
    }

    53.85% {
        background-position-x: -2520px;
    }

    56.41% {
        background-position-x: -2640px;
    }

    58.97% {
        background-position-x: -2760px;
    }

    61.54% {
        background-position-x: -2880px;
    }

    64.10% {
        background-position-x: -3000px;
    }

    66.67% {
        background-position-x: -3120px;
    }

    69.23% {
        background-position-x: -3240px;
    }

    71.79% {
        background-position-x: -3360px;
    }

    74.36% {
        background-position-x: -3480px;
    }

    76.92% {
        background-position-x: -3600px;
    }

    79.49% {
        background-position-x: -3720px;
    }

    82.05% {
        background-position-x: -3840px;
    }

    84.62% {
        background-position-x: -3960px;
    }

    87.18% {
        background-position-x: -4080px;
    }

    89.74% {
        background-position-x: -4200px;
    }

    92.31% {
        background-position-x: -4320px;
    }

    94.87% {
        background-position-x: -4440px;
    }

    97.44% {
        background-position-x: -4560px;
    }

    100.00% {
        background-position-x: -4680px;
    }
}
.tabs{
  overflow: hidden;
  margin-bottom: 35px;
  .tablist{
    width: 160px;
    height: 160px;
    text-align: center;
    cursor: pointer;
    border-radius: 6px;
  }
  .tabimage{
    display: inline-block;
    width: 80px;
    height: 80px;
    margin: 12px  auto;
  }
  .isactive{
    background: rgba(255,255,255,0.2);
  }
}
</style>
